(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["account-login"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function() {
    const recoverPass = document.getElementById('RecoverPassword');
    const hideRecoverPass = document.getElementById('HideRecoverPasswordLink');
    const recoverPassForm = document.getElementById('RecoverPasswordForm');
    const customerLoginForm = document.getElementById('CustomerLoginForm');
    const email = document.getElementById('RecoverEmail');
    const resetSuccess = document.getElementById('ResetSuccess');
    const validEmail = document.getElementById('ValidEmail');
    const resetTooManyAttemptsMessage = document.getElementById('ResetToManyAttempts');
    const form = document.querySelector('#recovery-pass');

    recoverPass?.addEventListener('click', function(evt) {
      evt.preventDefault();
      toggleRecoverPasswordForm();
    });

    hideRecoverPass?.addEventListener('click', function(evt) {
      evt.preventDefault();
      toggleRecoverPasswordForm();
    });

    /** Show/Hide recover password form **/
    function toggleRecoverPasswordForm() {
      recoverPassForm.classList.toggle('d-none');
      customerLoginForm.classList.toggle('d-none');
    }

    /** Show reset password success message */
    function resetPasswordSuccess() {
      const formState = document.getElementsByClassName('reset-password-success');
      // check if reset password form was successfully submitted.
      if (!formState) {
        return;
      }
    }

    function isValidEmail(email) {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return emailRegex.test(email);
    }

    form.addEventListener('submit', function(event) {
      event.preventDefault();
      event.stopImmediatePropagation();

      if (!isValidEmail(email.value)) {
        validEmail.classList.remove('d-none');
        return;
      }

      const dataToSend = {
        email: email.value,
      };

      fetch('/account/recover', {
        method: 'POST',
        cache: 'no-cache',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(dataToSend),
      })
      .then(response => {
        const errorsContainer = document.querySelector('.errors');
        toggleRecoverPasswordForm();
        resetSuccess?.classList.remove('d-none');
        errorsContainer?.classList.add('d-none');
      })
      .catch(error => {
        resetTooManyAttemptsMessage.classList.remove('d-none');
      });
    });

    resetPasswordSuccess();
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["add-to-cart-sibling"] && !Shopify.designMode) return;
  try {
    (function () {
    class AddToCartUIHandler {
      constructor(atcElement) {
        this.atcBlock = atcElement;
        this.blockId = atcElement.dataset.addToCartBlock;
        this.config = this.getConfig();

        if (!this.config) return;

        this.button = this.atcBlock.querySelector('[data-add-to-cart]');
        this.variantInput = this.atcBlock.querySelector('[data-variant-input]');
        this.termsCheckbox = this.atcBlock.querySelector('input[name="terms"]');

        this.init();
      }

      getConfig() {
        try {
          const configEl = document.querySelector(`[data-add-to-cart-data="${this.blockId}"]`);
          return configEl ? JSON.parse(configEl.textContent) : null;
        } catch (e) {
          return null;
        }
      }

      init() {
        if (!this.button) return;
        
        this.listenForVariantChanges();
        this.bindTermsCheckbox();
      }

      bindTermsCheckbox() {
        if (!this.termsCheckbox) return;

        this.termsCheckbox.addEventListener('change', () => {
          if (this.termsCheckbox.checked) {
            this.atcBlock.classList.remove('pdp-atc-error');
            const errEl = this.atcBlock.querySelector('[data-terms-error]');
            if (errEl) {
              errEl.textContent = '';
              errEl.classList.add('d-none');
            }
          }
          this.updateButtonState();
        });

        this.updateButtonState();
      }

      updateButtonState() {
        const currentVariantAvailable = this.button.getAttribute('data-variant-available') !== 'false';
        if (!currentVariantAvailable) {
          this.button.disabled = true;
        } else {
          this.button.disabled = false;
        }
      }

      listenForVariantChanges() {
        document.addEventListener('variant:changed', (e) => {
          if (e.detail?.variant) {
            this.updateForVariant(e.detail.variant);
          }
        });
      }

      updateForVariant(variant) {
        if (this.variantInput) {
          this.variantInput.value = variant.id;
        }
        
        const isAvailable = variant.available !== false;
        this.button.setAttribute('data-variant-available', isAvailable);

        if (isAvailable) {
          this.button.textContent = this.config.buttonText;
          this.button.classList.remove('disabled');
        } else {
          this.button.textContent = this.config.soldOutText;
          this.button.classList.add('disabled');
          this.button.disabled = true;
        }

        if (variant.color && variant.bundle) {
          this.button.setAttribute('bi-id', variant.color + ' / ' + variant.bundle);
        }

        this.updateButtonState();
      }
    }

    function initAddToCartBlocksInContainer(container) {
      if (!container) return;
      const atcBlocks = container.querySelectorAll('[data-add-to-cart-block]');
      atcBlocks.forEach((block) => {
        if (block.addToCartUIHandlerInstance) return;
        block.addToCartUIHandlerInstance = new AddToCartUIHandler(block);
      });
    }

    document.addEventListener('DOMContentLoaded', function () {
      document.addEventListener('submit', function(e) {
        const form = e.target && e.target.tagName && e.target.tagName.toLowerCase() === 'form' ? e.target : null;
        if (!form || !form.closest || !form.closest('.sibling-product-section')) return;
        if (!form.querySelector('[data-add-to-cart]')) return;
        e.preventDefault();
        e.stopPropagation();

        if (typeof window.addSiblingProductToCart !== 'function') {
          form.submit();
          return;
        }

        window.addSiblingProductToCart({
          sectionEl: form.closest('.sibling-product-section'),
          form: form,
        });
      }, true);
      
      initAddToCartBlocksInContainer(document);
    });

    window.initAddToCartBlocksInContainer = initAddToCartBlocksInContainer;
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["add-to-cart"] && !Shopify.designMode) return;
  try {
    (function () {
    class AddToCartUIHandler {
      constructor(atcElement) {
        this.atcBlock = atcElement;
        this.blockId = atcElement.dataset.addToCartBlock;
        this.config = this.getConfig();

        if (!this.config) return;

        this.button = this.atcBlock.querySelector('[data-add-to-cart]');
        this.variantInput = this.atcBlock.querySelector('[data-variant-input]');
        this.termsWrapper = this.atcBlock.querySelector('.terms-wrapper');
        this.termsCheckbox = this.atcBlock.querySelector('[data-terms-checkbox]');
        this.termsError = this.atcBlock.querySelector('[data-terms-error]');
        this.form = this.atcBlock.querySelector('[data-product-form]');

        this.init();
      }

      getConfig() {
        try {
          const configEl = document.querySelector(`[data-add-to-cart-data="${this.blockId}"]`);
          return configEl ? JSON.parse(configEl.textContent) : null;
        } catch (e) {
          return null;
        }
      }

      init() {
        if (!this.button) return;
        
        this.listenForVariantChanges();
        this.bindTermsCheckbox();
        this.bindFormSubmit();
        
        document.addEventListener(
          'machinePDP:ready',
          () => {
            if (window.machinePDPInstance) {
              this.bindButtonClick();
            }
          },
          { once: true }
        );
        
        if (window.machinePDPInstance) {
          this.bindButtonClick();
        }
      }

      bindButtonClick() {
        if (!this.button) return;

        this.button.onclick = (e) => {
          e.preventDefault();
          
          const currentVariantId = this.variantInput.value;
          const variantData = this.config.variants[currentVariantId];
          const isCheckboxRequired = variantData && variantData.checkboxRequired;

          if (isCheckboxRequired && this.termsCheckbox && !this.termsCheckbox.checked) {
            this.showError();
            return false;
          }

          this.hideError();
          
          if (window.machinePDPInstance && typeof window.machinePDPInstance.addProductToCart === 'function') {
            window.machinePDPInstance.addProductToCart();
          }
        };
      }

      createTermsCheckbox() {
        if (!this.termsWrapper) {
          this.termsWrapper = document.createElement('div');
          this.termsWrapper.className = 'terms-wrapper mb-3';
          this.termsWrapper.innerHTML = `
            <label class="terms-checkbox d-flex align-items-start gap-1 pointer">
              <input
                type="checkbox"
                name="terms"
                class="mt-1 pointer"
                data-terms-checkbox
                required
              >
              <span class="fs14">${this.config.termsText}</span>
            </label>
          `;
          this.form.insertBefore(this.termsWrapper, this.button);
          this.termsCheckbox = this.termsWrapper.querySelector('[data-terms-checkbox]');
          this.bindTermsCheckbox();
        }

        if (!this.termsError) {
          this.termsError = document.createElement('div');
          this.termsError.className = 'terms-error-message text-danger fs12 mt-12 text-center';
          this.termsError.style.display = 'none';
          this.termsError.setAttribute('data-terms-error', '');
          this.termsError.textContent = this.config.errorMessage;
          this.button.parentNode.insertBefore(this.termsError, this.button.nextSibling);
        }
      }

      removeTermsCheckbox() {
        if (this.termsWrapper) {
          this.termsWrapper.remove();
          this.termsWrapper = null;
          this.termsCheckbox = null;
        }
        if (this.termsError) {
          this.termsError.remove();
          this.termsError = null;
        }
      }

      bindFormSubmit() {
        if (!this.form) return;

        this.form.addEventListener('submit', (e) => {
          const currentVariantId = this.variantInput.value;
          const variantData = this.config.variants[currentVariantId];
          const isCheckboxRequired = variantData && variantData.checkboxRequired;

          if (isCheckboxRequired && this.termsCheckbox && !this.termsCheckbox.checked) {
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();
            this.showError();
            return false;
          }

          this.hideError();
        }, true); 
      }

      bindTermsCheckbox() {
        if (!this.termsCheckbox) return;

        const oldCheckbox = this.termsCheckbox;
        const newCheckbox = oldCheckbox.cloneNode(true);
        oldCheckbox.parentNode.replaceChild(newCheckbox, oldCheckbox);
        this.termsCheckbox = newCheckbox;

        this.termsCheckbox.addEventListener('change', () => {
          if (this.termsCheckbox.checked) {
            this.hideError();
          }
          this.updateButtonState();
        });

        this.updateButtonState();
      }

      showError() {
        if (this.termsError) {
          this.termsError.style.display = 'block';
        }
      }

      hideError() {
        if (this.termsError) {
          this.termsError.style.display = 'none';
        }
      }

      updateButtonState() {
        const currentVariantId = this.variantInput.value;
        const variantData = this.config.variants[currentVariantId];
        const isCheckboxRequired = variantData && variantData.checkboxRequired;
      }

      updateCheckboxVisibility(variantId) {
        const variantData = this.config.variants[String(variantId)];
        const isCheckboxRequired = variantData && variantData.checkboxRequired;

        this.atcBlock.setAttribute('data-checkbox-required', isCheckboxRequired);

        if (isCheckboxRequired) {
          this.createTermsCheckbox();
        } else {
          this.removeTermsCheckbox();
        }

        this.hideError();
      }

      listenForVariantChanges() {
        document.addEventListener('variant:changed', (e) => {
          if (e.detail?.variant) {
            this.updateForVariant(e.detail.variant);
          }
        });
      }

      updateForVariant(variant) {
        if (this.variantInput) {
          this.variantInput.value = variant.id;
        }
        
        const isAvailable = variant.available !== false;
        this.button.setAttribute('data-variant-available', isAvailable);

        if (isAvailable) {
          this.button.textContent = this.config.buttonText;
          this.button.classList.remove('disabled');
          this.button.disabled = false;
        } else {
          this.button.textContent = this.config.soldOutText;
          this.button.classList.add('disabled');
          this.button.disabled = true;
        }

        if (variant.color && variant.bundle) {
          this.button.setAttribute('bi-id', variant.color + ' / ' + variant.bundle);
        }

        this.updateCheckboxVisibility(variant.id);
        this.updateButtonState();
      }
    }

    document.addEventListener('DOMContentLoaded', function () {
      const atcBlocks = document.querySelectorAll('[data-add-to-cart-block]');
      atcBlocks.forEach((block) => {
        new AddToCartUIHandler(block);
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["bundle-badge"] && !Shopify.designMode) return;
  try {
    (function () {
    class BundleBadge {
      constructor() {
        this.init();
      }

      init() {
        this.showAppropriateBundleContainers();
      }

      showAppropriateBundleContainers() {
        const allContainers = document.querySelectorAll('[class^="bundles-"], [class*=" bundles-"]');

        allContainers.forEach((container) => {
          const containerVariantId = this.extractVariantIdFromContainer(container);

          if (!containerVariantId) return;

          const badgesInContainer = Array.from(container.querySelectorAll('[data-bundle-badge-block]'));

          if (badgesInContainer.length === 0) return;

          const matchingBadges = [];
          const defaultBadges = [];

          badgesInContainer.forEach((badge) => {
            const showInVariants = badge.dataset.showInVariants || '';

            if (showInVariants.trim() === '') {
              defaultBadges.push(badge);
            } else if (this.shouldShowInContainer(containerVariantId, showInVariants)) {
              matchingBadges.push(badge);
            }
          });

          let badgeToShow = null;

          if (matchingBadges.length > 0) {
            badgeToShow = matchingBadges[0];
          } else if (defaultBadges.length > 0) {
            badgeToShow = defaultBadges[0];
          }

          badgesInContainer.forEach((badge) => {
            badge.style.display = 'none';
            badge.setAttribute('data-hidden', '');
          });

          if (badgeToShow) {
            badgeToShow.style.display = 'inline-block';
            badgeToShow.removeAttribute('data-hidden');
            container.style.display = 'block';
          } else {
            container.style.display = 'none';
          }
        });
      }

      extractVariantIdFromContainer(container) {
        const classList = Array.from(container.classList);
        const bundleClass = classList.find((cls) => cls.startsWith('bundles-'));

        if (bundleClass) {
          return bundleClass.replace('bundles-', '');
        }

        return container.dataset.variantId || null;
      }

      shouldShowInContainer(containerVariantId, showInVariants) {
        const allowedIds = showInVariants
          .split(',')
          .map((id) => id.trim())
          .filter((id) => id !== '');

        return allowedIds.includes(String(containerVariantId));
      }
    }

    window.BundleBadge = new BundleBadge();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["bundle-selector-sibling"] && !Shopify.designMode) return;
  try {
    (function () {
    function getActiveCurrencyCode() {
      try {
        if (typeof window !== 'undefined' && window.Shopify && window.Shopify.currency) {
          return window.Shopify.currency.active || window.Shopify.currency.currency || window.Shopify.currency.iso_code || null;
        }
      } catch (e) {}
      return null;
    }

    function formatMoney(cents) {
      const code = getActiveCurrencyCode();
      if (typeof Intl !== 'undefined' && code) {
        return new Intl.NumberFormat(undefined, {
          style: 'currency',
          currency: code,
          currencyDisplay: 'narrowSymbol',
        }).format((cents || 0) / 100);
      }

      const amount = ((cents || 0) / 100).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
      return code ? `${amount} ${code}` : amount;
    }

    function parseJsonScriptElement(el) {
      if (!el) return null;
      try {
        return JSON.parse(el.textContent || '{}');
      } catch (e) {
        return null;
      }
    }

    function encodeYotpoImageUrl(url) {
      if (!url) return '';
      return String(url).replace(/\?/g, '%3F').replace(/&/g, '%26');
    }

    function featuredImageLargeUrl(product) {
      if (!product) return '';
      const img = product.featured_image || product.image;
      if (!img) return '';
      if (typeof img === 'string') return img;
      if (img.src) return img.src;
      return '';
    }

    /**
     * Sibling section swaps replace only `shopify-section-*`, but Yotpo reviews/stars can live outside that subtree.
     * After reload, sync Yotpo placeholders to the newly loaded product and re-init widgets.
     */
    function refreshYotpoWidgetsAfterSiblingSectionReload(newSectionRoot) {
      if (!newSectionRoot) return;

      const sectionProductEl =
        newSectionRoot.querySelector('.sibling-product-section [data-product-json]') ||
        newSectionRoot.querySelector('[data-product-json]');
      const product = parseJsonScriptElement(sectionProductEl);
      if (!product || !product.id) return;

      const productId = String(product.id);
      const title = product.title != null ? String(product.title) : '';
      const description =
        (product.body_html != null ? String(product.body_html) : '') ||
        (product.description != null ? String(product.description) : '');
      const url = product.url ? String(product.url) : '';
      const absUrl = url && url.indexOf('http') === 0 ? url : (typeof window !== 'undefined' && window.location && window.location.origin ? window.location.origin + url : url);
      const imageUrl = encodeYotpoImageUrl(featuredImageLargeUrl(product));

      const selectedVariant =
        (Array.isArray(product.variants) ? product.variants.find(function (v) { return v && String(v.id) === String(product.selected_or_first_available_variant?.id); }) : null) ||
        product.selected_or_first_available_variant ||
        (Array.isArray(product.variants) ? product.variants[0] : null);
      const priceCents = selectedVariant && selectedVariant.price != null ? selectedVariant.price : null;
      const currency = (typeof window !== 'undefined' && window.Shopify && window.Shopify.currency && window.Shopify.currency.active)
        ? String(window.Shopify.currency.active)
        : '';

      // Yotpo v3 widget instances (stars + reviews)
      document.querySelectorAll('.yotpo-widget-instance[data-yotpo-instance-id][data-yotpo-product-id]').forEach(function (node) {
        if (newSectionRoot.contains(node)) return;
        node.setAttribute('data-yotpo-product-id', productId);
        if (title) node.setAttribute('data-yotpo-name', title);
        if (absUrl) node.setAttribute('data-yotpo-url', absUrl);
        if (imageUrl) node.setAttribute('data-yotpo-image-url', imageUrl);
        if (description) node.setAttribute('data-yotpo-description', description);
        node.innerHTML = '';
      });

      // Yotpo v2 widgets
      document.querySelectorAll('.yotpo.bottomLine[data-product-id]').forEach(function (node) {
        if (newSectionRoot.contains(node)) return;
        node.setAttribute('data-product-id', productId);
        node.innerHTML = '';
      });

      document.querySelectorAll('.yotpo.yotpo-main-widget[data-product-id]').forEach(function (node) {
        if (newSectionRoot.contains(node)) return;
        node.setAttribute('data-product-id', productId);
        if (title) node.setAttribute('data-name', title);
        if (absUrl) node.setAttribute('data-url', absUrl);
        if (imageUrl) node.setAttribute('data-image-url', imageUrl);
        if (description) node.setAttribute('data-description', description);
        if (priceCents != null) node.setAttribute('data-price', String(priceCents));
        if (currency) node.setAttribute('data-currency', currency);
        node.innerHTML = '';
      });

      function runYotpoInit() {
        try {
          if (window.yotpoWidgetsContainer && typeof window.yotpoWidgetsContainer.initWidgets === 'function') {
            window.yotpoWidgetsContainer.initWidgets();
          } else if (window.yotpo && typeof window.yotpo.refreshWidgets === 'function') {
            window.yotpo.refreshWidgets();
          } else if (window.yotpo && typeof window.yotpo.initWidgets === 'function') {
            window.yotpo.initWidgets();
          }
        } catch (e) {}
      }

      // Defer one tick so DOM mutations settle before Yotpo scans placeholders.
      if (typeof window.requestAnimationFrame === 'function') {
        window.requestAnimationFrame(function () { runYotpoInit(); });
      } else {
        setTimeout(runYotpoInit, 0);
      }
    }

    class BundleSelectorSibling {
      static urlVariantId() {
        return new URLSearchParams(location.search).get('variant');
      }

      static isRestoring(sectionEl) {
        return sectionEl?.classList.contains('sibling-product-section--pending-load');
      }

      static showSection(sectionEl) {
        if (!sectionEl) return;
        sectionEl.classList.remove('sibling-product-section--pending-load');
      }

      static sectionProducts(sectionEl) {
        const root = sectionEl?.closest('[id^="shopify-section-"]') || sectionEl?.parentElement || document;
        return {
          product: parseJsonScriptElement(root.querySelector('[data-product-json]')),
          sibling: parseJsonScriptElement(root.querySelector('[data-sibling-product-json]')),
        };
      }

      static hasVariant(product, variantId) {
        return !!(variantId && product?.variants?.some((v) => v && String(v.id) === String(variantId)));
      }

      static getVisibleVariantSelector(container) {
        const block = container?.querySelector('[data-variant-selector-block]:not(.d-none)');
        const variantOptions = block?.querySelectorAll('.variant-option[data-variant-id]');
        return block && variantOptions?.length ? { block, variantOptions } : null;
      }

      static getVariantOptionSelection(sectionEl) {
        const selector = BundleSelectorSibling.getVisibleVariantSelector(sectionEl);
        if (!selector) return null;
        const selectedIndex = [...selector.variantOptions].findIndex((btn) =>
          btn.classList.contains('selected')
        );
        const index = selectedIndex >= 0 ? selectedIndex : 0;
        return {
          index,
          optionValue: selector.variantOptions[index]?.dataset.optionValue || null,
        };
      }

      static applyVariantOptionSelection(container, selection) {
        if (!selection) return;

        const selector = BundleSelectorSibling.getVisibleVariantSelector(container);
        if (!selector) return;

        const { block, variantOptions } = selector;
        const btn = [...variantOptions].find((option) =>
          option.dataset.optionValue === selection.optionValue
        ) || variantOptions[Math.min(selection.index, variantOptions.length - 1)];
        const { optionValue, variantId } = btn?.dataset || {};
        if (!optionValue || !variantId || btn.disabled || btn.classList.contains('selected')) return;

        const inst = block.variantSelectorInstance;
        if (inst?.selectOption) {
          inst.selectOption(optionValue, variantId);
          return;
        }
        btn.click();
      }

      static syncSectionUrl(sectionEl) {
        if (!sectionEl) return;
        const url = new URL(location.href);
        const variantId = sectionEl.querySelector('[data-variant-selector-block]:not(.d-none)')?.getAttribute('data-current-variant') ||
          sectionEl.getAttribute('data-current-variant');
        variantId ? url.searchParams.set('variant', variantId) : url.searchParams.delete('variant');
        const href = url.pathname + url.search;
        if (href !== location.pathname + location.search) {
          history.replaceState({ path: href }, '', href);
        }
      }

      static finishSectionRestore(sectionEl) {
        BundleSelectorSibling.syncSectionUrl(sectionEl);
        document.querySelectorAll('.sibling-product-section--pending-load').forEach((el) => {
          BundleSelectorSibling.showSection(el);
        });
      }

      constructor(selectorElement) {
        this.selector = selectorElement;
        this.blockId = selectorElement.dataset.bundleSelectorBlock;
        this.config = this.getConfig();

        if (!this.config) return;

        this.mainAccordion = this.selector.querySelector('[data-bundle-accordion-type="main"]');
        this.subscriptionAccordion = this.selector.querySelector('.bundle-accordion-subscription');
        this.exchangeAccordion = this.selector.querySelector('.bundle-accordion-exchange');
        this.mainPriceEl = this.mainAccordion?.querySelector('[data-main-price]');
        this.subscriptionShippingEl = this.subscriptionAccordion?.querySelectorAll('[data-subscription-shipping-price]');
        this.exchangeShippingEl = this.exchangeAccordion?.querySelector('[data-subscription-shipping-price]');
        this.currentVariantId = this.config.currentVariantId;
        this.init();
      }
      
      getAccordionScope() {
        const sectionId = this.getSectionId();
        return sectionId || this.blockId;
      }
      
      getSectionId() {
        const sectionEl = this.selector.closest('[data-section-id]');
        return sectionEl?.getAttribute('data-section-id') || sectionEl?.dataset?.sectionId || null;
      }

      getConfig() {
        return window.bundleSelectorData[this.blockId] || null;
      }

      getI18n() {
        const defaults = {
          quantityMaxLimitError: 'Maximum quantity for this option is [limit]',
          quantityMinLimitError: 'Minimum quantity for this option is [limit]',
        };
        return Object.assign({}, defaults, (this.config && this.config.i18n) ? this.config.i18n : {});
      }

      getFrequencyLabels(dropdownEl) {
        return {
          everyPrefix: dropdownEl?.getAttribute('data-frequency-every-prefix') || '',
          monthSingular: dropdownEl?.getAttribute('data-frequency-month-singular') || '',
          monthPlural: dropdownEl?.getAttribute('data-frequency-month-plural') || '',
        };
      }

      formatFrequencyOptionLabel(period, frequencyLabels) {
        if (period == null || period === '') {
          return '';
        }
        const periodNumber = Number(period);
        const labels = frequencyLabels || {};
        const monthWord = periodNumber === 1
          ? (labels.monthSingular || '')
          : (labels.monthPlural || '');
        const prefix = String(labels.everyPrefix || '').trim();
        return [prefix, String(periodNumber), monthWord].filter(Boolean).join(' ');
      }

      getAccordionShippingLabels(accordion) {
        return {
          shippingLabel: accordion?.getAttribute('data-shipping-label') || '',
          freeShippingLabel: accordion?.getAttribute('data-free-shipping-label') || '',
        };
      }

      init() {
        if (this.syncProductFromUrl()) return;
        if (this.syncProductFromDefaultOption()) return;

        this.bindAccordionHeads();
        this.bindFrequencySelectChange();
        this.listenForVariantChanges();
        this.listenForQuantityChanges();
        this.updateFrequencyDropdown();
        this.updateSellingPlanData();
        this.updateLineItemsToSubscribe();
        const selectedAccordion = this.selector.querySelector('.bundle-accordion.selected, .bundle-accordion-main');
        if (selectedAccordion) this.syncSectionQuantityLimit(selectedAccordion);
        this.updateQuantityLimitErrors();
      }

      syncSectionQuantityLimit(accordionEl) {
        const sectionEl = this.getSectionElement();
        if (!sectionEl || !sectionEl.hasAttribute('data-max-qty')) return;
        const maxLimit = sectionEl.getAttribute('data-max-qty') || '99';
        const minLimit = sectionEl.getAttribute('data-min-qty') || '1';
        const limit = (accordionEl && accordionEl.dataset.quantityMaxLimit) ? accordionEl.dataset.quantityMaxLimit : maxLimit;
        const limitNum = parseInt(limit, 10);
        const effectiveLimit = (!isNaN(limitNum) && limitNum > 0) ? String(limitNum) : maxLimit;
        const isSubscriptionAccordion = !!(accordionEl && accordionEl.classList && accordionEl.classList.contains('bundle-accordion-subscription'));
        const effectiveMin = (() => {
          if (isSubscriptionAccordion) {
            const minLimit = (accordionEl && accordionEl.dataset.quantityMinLimit) ? accordionEl.dataset.quantityMinLimit : minLimit;
            const minNum = parseInt(minLimit, 10);
            return (!isNaN(minNum) && minNum > 0) ? String(minNum) : minLimit;
          }
          const minLimit = (accordionEl && accordionEl.dataset.quantityMinLimit) ? accordionEl.dataset.quantityMinLimit : '1';
          const minNum = parseInt(minLimit, 10);
          return (!isNaN(minNum) && minNum > 0) ? String(minNum) : '1';
        })();
        sectionEl.setAttribute('data-quantity-limitation', effectiveLimit);
        sectionEl.dataset.quantityLimitation = effectiveLimit;
        const qtyBlocks = sectionEl.querySelectorAll('[data-quantity-selector-block]');
        qtyBlocks.forEach((blockEl) => {
          const input = blockEl.querySelector('.quantity-selector-input');
          const max = parseInt(effectiveLimit, 10) || 99;
          const min = parseInt(effectiveMin, 10) || 1;
          if (blockEl && blockEl.dataset) blockEl.dataset.max = String(max);
          if (blockEl && blockEl.dataset) blockEl.dataset.min = String(min);
          if (input) {
            input.max = String(max);
            input.min = String(min);
            const val = parseInt(input.value, 10) || min;
            if (val > max) {
              input.value = String(max);
              input.dispatchEvent(new Event('change', { bubbles: true }));
              input.dispatchEvent(new Event('input', { bubbles: true }));
            } else if (val < min) {
              input.value = String(min);
              input.dispatchEvent(new Event('change', { bubbles: true }));
              input.dispatchEvent(new Event('input', { bubbles: true }));
            }
          }
        });
      }

      updateRadioIcon(accordionEl, isSelected) {
        if (!accordionEl) return;
        const radioEl = accordionEl.querySelector('.radio');
        if (!radioEl) return;
        
        const selectedSVG = '<svg width="20" height="20" viewBox="0 0 20 20" fill="none"><rect x="0.5" y="0.5" width="19" height="19" rx="9.5" fill="#005BAB"></rect><path d="M5 10L7.5 13L14 7.5" stroke="white" stroke-width="1.5"></path></svg>';
        const unselectedSVG = '<svg width="20" height="20" viewBox="0 0 20 20" fill="none"><circle cx="10" cy="10" r="9.5" stroke="#1E3A8A" stroke-width="1.5"></circle></svg>';
        
        radioEl.innerHTML = isSelected ? selectedSVG : unselectedSVG;
      }

      setSelectedAccordion(accordionEl) {
        if (!accordionEl) return;
        const accordionScope = this.getAccordionScope();

        const label = (accordionEl.querySelector('[data-bundle-name]')?.textContent || '').trim();
        const accordionSelection = accordionEl.querySelector('.accordion-selection');
        if (label) {
          const elementType =
            (accordionSelection?.getAttribute && accordionSelection?.getAttribute('bi-type')) || '';
          (window.preDataLayer = window.preDataLayer || []).push({
            event: 'newEvent',
            newEventData: {
              type: 'Click',
              elementType: elementType,
              elementId: label
            }
          });
        }

        this.selector.querySelectorAll(`[data-bundle-accordion="${accordionScope}"]`).forEach((acc) => {
          acc.classList.remove('selected');
          this.updateRadioIcon(acc, false);
        });

        accordionEl.classList.add('selected');
        this.updateRadioIcon(accordionEl, true);
        this.syncSectionQuantityLimit(accordionEl);
      }

      syncProductFromUrl() {
        const section = this.getSectionElement();
        if (!section) return false;

        const urlVariantId = BundleSelectorSibling.urlVariantId();
        if (!urlVariantId) return false;

        const { product, sibling } = BundleSelectorSibling.sectionProducts(section);

        if (BundleSelectorSibling.hasVariant(product, urlVariantId)) {
          if (section.dataset.changeDefaultProduct === 'true') {
            section.dataset.changeDefaultProduct = 'false';
            section.removeAttribute('data-default-product-handle');
          }
          BundleSelectorSibling.finishSectionRestore(section);
          return false;
        }

        const siblingHandle = BundleSelectorSibling.hasVariant(sibling, urlVariantId) ? sibling?.handle : null;
        if (!siblingHandle || product?.handle === siblingHandle) {
          BundleSelectorSibling.finishSectionRestore(section);
          return false;
        }

        this.loadSiblingProduct(siblingHandle);
        return true;
      }

      syncProductFromDefaultOption() {
        const section = this.getSectionElement();
        if (!section || section.dataset.changeDefaultProduct !== 'true') return false;
        if (BundleSelectorSibling.urlVariantId()) return false;

        const handle = section.dataset.defaultProductHandle;
        if (!handle) return false;

        const { product } = BundleSelectorSibling.sectionProducts(section);
        if (product?.handle === handle) {
          BundleSelectorSibling.finishSectionRestore(section);
          return false;
        }

        this.loadSiblingProduct(handle);
        return true;
      }

      getBundleOptions() {
        const sectionEl = this.getSectionElement();
        if (!sectionEl || sectionEl === document) return [];
        try {
          let raw = sectionEl.getAttribute('data-bundle-options') || sectionEl.dataset.bundleOptions || '[]';
          if (typeof raw !== 'string') raw = '[]';
          raw = raw.replace(/&quot;/g, '"').replace(/&#39;/g, "'").replace(/&amp;/g, '&');
          return JSON.parse(raw);
        } catch (e) {
          return [];
        }
      }

      getBundleOptionForQuantity(qty, options) {
        const list = Array.isArray(options) ? options : this.getBundleOptions();
        if (!Array.isArray(list) || list.length === 0) return null;
        for (let i = 0; i < list.length; i++) {
          const opt = list[i];
          if (opt && opt.quantity != null && Number(opt.quantity) === Number(qty)) {
            return opt;
          }
        }
        return null;
      }

      /** Keeps custom frequency trigger/panel in sync when the hidden select changes (see bundle-accordion-item). */
      static syncFrequencyDropdownUI(selectEl) {
        if (!selectEl) return;
        const wrap = selectEl.closest('[data-frequency-dropdown]');
        if (!wrap) return;
        const triggerText = wrap.querySelector('.bundle-accordion-frequency-trigger-text');
        const triggerBadge = wrap.querySelector('[data-frequency-trigger-badge]');
        const trigger = wrap.querySelector('[data-frequency-trigger]');
        const panel = wrap.querySelector('[data-frequency-panel]');
        const sellingPlanInput = wrap.closest('[data-frequency-from-bundle]')?.querySelector('[data-selling-plan-input]');
        const badgeOptionIndex = parseInt(wrap.dataset.badgeOptionIndex || '0', 10);
        const badgeText = wrap.dataset.badgeText || '';
        const frequencyBadgeBlockId = wrap.dataset.frequencyBadgeBlockId || '';

        if (panel && selectEl.options.length !== panel.querySelectorAll('.bundle-accordion-frequency-option').length) {
          const fragment = document.createDocumentFragment();
          for (let j = 0; j < selectEl.options.length; j++) {
            const optRow = selectEl.options[j];
            const btn = document.createElement('button');
            const oneBased = j + 1;
            const showBadge = badgeOptionIndex > 0 && oneBased === badgeOptionIndex && badgeText;
            btn.type = 'button';
            let btnClass = 'bundle-accordion-frequency-option' + (j === selectEl.selectedIndex ? ' selected' : '');
            if (showBadge) btnClass += ' has-badge';
            btn.className = btnClass;
            btn.setAttribute('role', 'option');
            btn.setAttribute('data-period', optRow.value);
            btn.setAttribute('aria-selected', j === selectEl.selectedIndex ? 'true' : 'false');
            if (optRow.dataset && optRow.dataset.sellingPlanId) btn.dataset.sellingPlanId = optRow.dataset.sellingPlanId;
            const textSpan = document.createElement('span');
            textSpan.className = 'bundle-accordion-frequency-option-text';
            textSpan.textContent = optRow.textContent || '—';
            btn.appendChild(textSpan);
            if (showBadge) {
              const badgeSpan = document.createElement('span');
              badgeSpan.className = 'bundle-accordion-frequency-badge' +
                (frequencyBadgeBlockId ? (' bundle-accordion-frequency-badge-' + frequencyBadgeBlockId) : '');
              badgeSpan.textContent = badgeText;
              btn.appendChild(badgeSpan);
            }
            fragment.appendChild(btn);
          }
          panel.innerHTML = '';
          panel.appendChild(fragment);
        }

        if (panel && panel.dataset.frequencyPanelBound !== 'true') {
          panel.dataset.frequencyPanelBound = 'true';
          panel.addEventListener('click', function (ev) {
            const btn = ev.target && ev.target.closest ? ev.target.closest('.bundle-accordion-frequency-option') : null;
            if (!btn || !panel.contains(btn)) return;
            ev.preventDefault();

            const buttons = Array.from(panel.querySelectorAll('.bundle-accordion-frequency-option'));
            const idx = buttons.indexOf(btn);
            if (idx < 0) return;
            selectEl.selectedIndex = idx;
            if (sellingPlanInput && btn.dataset && btn.dataset.sellingPlanId) {
              sellingPlanInput.value = btn.dataset.sellingPlanId;
            }
            selectEl.dispatchEvent(new Event('change', { bubbles: true }));
            BundleSelectorSibling.syncFrequencyDropdownUI(selectEl);
            panel.setAttribute('aria-hidden', 'true');
            if (trigger) trigger.setAttribute('aria-expanded', 'false');
          });
        }

        const opt = selectEl.options[selectEl.selectedIndex];
        if (triggerText && opt) {
          triggerText.textContent = opt.textContent || '—';
        }
        if (sellingPlanInput && opt && opt.dataset && opt.dataset.sellingPlanId) {
          sellingPlanInput.value = opt.dataset.sellingPlanId;
        }
        if (triggerBadge && badgeText) {
          const selectedOneBased = selectEl.selectedIndex + 1;
          if (selectedOneBased === badgeOptionIndex) {
            triggerBadge.textContent = badgeText;
            triggerBadge.classList.remove('d-none');
            triggerBadge.setAttribute('aria-hidden', 'false');
          } else {
            triggerBadge.textContent = '';
            triggerBadge.classList.add('d-none');
            triggerBadge.setAttribute('aria-hidden', 'true');
          }
        }
        if (panel) {
          panel.querySelectorAll('.bundle-accordion-frequency-option').forEach(function (btn, i) {
            const sel = selectEl.selectedIndex === i;
            btn.classList.toggle('selected', sel);
            btn.setAttribute('aria-selected', sel ? 'true' : 'false');
          });
        }
      }

      updateFrequencyDropdown() {
        const container = this.subscriptionAccordion?.querySelector('[data-frequency-from-bundle]');
        const selectEl = this.subscriptionAccordion?.querySelector('[data-frequency-select]');
        if (!container || !selectEl) return;

        const previousPeriod =
          selectEl.value !== '' && selectEl.value != null ? String(selectEl.value) : null;

        const qty = this.getQuantity();
        const subscriptionDefinition = this.getBundleOptions();
        const matchingOption = this.getBundleOptionForQuantity(qty, subscriptionDefinition);
        const frequencies = (matchingOption && Array.isArray(matchingOption.frequencies)) ? matchingOption.frequencies : [];

        selectEl.innerHTML = '';

        if (frequencies.length === 0) {
          container.style.display = 'none';
          this.updateLineItemsToSubscribe();
          return;
        }

        container.style.display = '';
        const frequencyLabels = this.getFrequencyLabels(selectEl.closest('[data-frequency-dropdown]'));
        frequencies.forEach((frequencyOption) => {
          const optionElement = document.createElement('option');
          optionElement.value = (frequencyOption && frequencyOption.period != null) ? String(frequencyOption.period) : '';
          optionElement.textContent = this.formatFrequencyOptionLabel(frequencyOption && frequencyOption.period, frequencyLabels);
          const sellingPlanId = frequencyOption?.selling_plan_id ?? null;
          if (sellingPlanId != null && sellingPlanId !== '') {
            optionElement.dataset.sellingPlanId = String(sellingPlanId);
          }
          selectEl.appendChild(optionElement);
        });

        const defaultOptionIndex = Math.max(1, parseInt(selectEl.closest('[data-frequency-dropdown]')?.dataset.defaultFrequencyOptionIndex || '1'));
        const defaultIdx = Math.min(frequencies.length - 1, defaultOptionIndex - 1);

        if (previousPeriod != null) {
          const options = Array.from(selectEl.options);
          const idx = options.findIndex(function (o) { return String(o.value) === previousPeriod; });
          if (idx >= 0) {
            selectEl.selectedIndex = idx;
          } else {
            selectEl.selectedIndex = defaultIdx;
          }
        } else {
          selectEl.selectedIndex = defaultIdx;
        }

        BundleSelectorSibling.syncFrequencyDropdownUI(selectEl);
        this.updateSellingPlanData();
        this.updateLineItemsToSubscribe();
      }

      bindFrequencySelectChange() {
        const selectEl = this.subscriptionAccordion?.querySelector('[data-frequency-select]');
        if (!selectEl) return;
        selectEl.addEventListener('change', () => {
          var opt = selectEl.options[selectEl.selectedIndex];
          this.updateShippingPrice();
          this.updateSellingPlanData();
          this.updateLineItemsToSubscribe();
        });
      }

      generateRandomNumericString(length) {
        let out = '';
        for (let i = 0; i < length; i++) {
          out += Math.floor(Math.random() * 10);
        }
        return out;
      }

      getForm() {
        return (
          this.selector.closest('form') ||
          document.querySelector('form [data-bundle-selector-block="' + this.blockId + '"]')?.closest('form') ||
          document.querySelector('form[action*="/cart/add"]') ||
          document.querySelector('form')
        );
      }

      getSectionElement() {
        return this.selector.closest('.sibling-product-section') || this.selector.closest('[data-section-id]') || document;
      }

      getQuantityInput() {
        const sectionEl = this.getSectionElement();
        const preferred = sectionEl.querySelector('.quantity-selector-input[name="quantity"]');
        if (preferred) return preferred;

        const form = this.getForm();
        if (form) {
          const formQty = form.querySelector('input[name="quantity"]');
          if (formQty) return formQty;
        }

        return sectionEl.querySelector('input[name="quantity"]') || document.querySelector('input[name="quantity"]');
      }

      isSubscriptionAccordionSelected() {
        const selected = this.selector.querySelector('.bundle-accordion.selected');
        return !!(selected && selected === this.subscriptionAccordion);
      }

      updateLineItemsToSubscribe() {
        let lineItemsToSubscribe = {};

        if (!this.isSubscriptionAccordionSelected()) {
          lineItemsToSubscribe = {
            _subscription_type: 'exchange',
            _shopify_non_subscription_item:
              this.getSectionElement()?.dataset?.enablePropertyExchange === 'true',
          };
          this.selector.dataset.lineItemsToSubscribe = JSON.stringify(lineItemsToSubscribe);
          if (this.selector?.dataset) {
            delete this.selector.dataset.sellingPlanId;
          }
          document.dispatchEvent(new CustomEvent('lineItemsToSubscribe:updated', { detail: lineItemsToSubscribe }));
          return;
        }

        const qty = this.getQuantity();
        const definition = this.getBundleOptions();
        const quantityOption = this.getBundleOptionForQuantity(qty, definition);
        const frequencySelect = this.subscriptionAccordion?.querySelector('[data-frequency-select]');
        const selectedOption = frequencySelect?.options?.[frequencySelect.selectedIndex] || null;
        const frequencies = Array.isArray(quantityOption?.frequencies) ? quantityOption.frequencies : [];
        const selectedFrequencyIndex = frequencySelect ? frequencySelect.selectedIndex : -1;
        let selectedFrequencyRule = null;

        if (
          selectedFrequencyIndex >= 0 &&
          frequencySelect &&
          frequencySelect.options.length === frequencies.length
        ) {
          selectedFrequencyRule = frequencies[selectedFrequencyIndex] || null;
        }

        if (!selectedFrequencyRule && selectedOption && frequencies.length > 0) {
          const selectedSellingPlanId = selectedOption.dataset?.sellingPlanId || '';
          if (selectedSellingPlanId) {
            selectedFrequencyRule = frequencies.find(function (frequencyRule) {
              const sellingPlanId = frequencyRule?.selling_plan_id;
              return sellingPlanId != null && String(sellingPlanId) === String(selectedSellingPlanId);
            }) || null;
          }
          if (!selectedFrequencyRule && selectedOption.value !== '') {
            selectedFrequencyRule = frequencies.find(function (frequencyRule) {
              return frequencyRule && String(frequencyRule.period) === String(selectedOption.value);
            }) || null;
          }
        }

        const daysToChargeNumber = Number(selectedFrequencyRule?.days_to_charge);
        const daysToCharge = Number.isFinite(daysToChargeNumber) ? daysToChargeNumber : 0;

        // Get selected frequency period
        const selectedFrequency = selectedOption?.value || selectedOption?.textContent || '';

        // Shipping is taken from the selected quantity option (not from frequencies)
        const shippingPrice = quantityOption?.shipping != null ? Number(quantityOption.shipping) : 0;

        if (definition && definition.length > 0) {
          lineItemsToSubscribe = {
            _shipping_price: shippingPrice,
            _cycle_frequency: Number(selectedFrequency),
            _days_to_charge: daysToCharge,
            _subscription: true,
            _unique_identifier: Date.now(),
            _subscription_type: 'co2'
          };
        } else if (this.selector?.dataset) {
          delete this.selector.dataset.sellingPlanId;
        }

        this.selector.dataset.lineItemsToSubscribe = JSON.stringify(lineItemsToSubscribe);
        document.dispatchEvent(new CustomEvent('lineItemsToSubscribe:updated', { detail: lineItemsToSubscribe }));
      }

      updateSellingPlanData() {
        // Keep the selected selling_plan_id available on the bundle selector element
        // so other blocks (e.g. add-to-cart) can read it consistently.
        const frequencySelect = this.subscriptionAccordion?.querySelector('[data-frequency-select]');
        const selectedOption = frequencySelect?.options?.[frequencySelect.selectedIndex] || null;
        const sellingPlanId = selectedOption?.dataset?.sellingPlanId || '';

        if (sellingPlanId) {
          this.selector.dataset.sellingPlanId = String(sellingPlanId);
          this.selector.setAttribute('data-selling-plan-id', String(sellingPlanId));
        } else {
          if (this.selector?.dataset) delete this.selector.dataset.sellingPlanId;
          this.selector.removeAttribute('data-selling-plan-id');
        }

        document.dispatchEvent(
          new CustomEvent('sellingPlanId:updated', {
            detail: { sellingPlanId: sellingPlanId || null, blockId: this.blockId },
          })
        );
      }

      bindAccordionHeads() {
        const accordionScope = this.getAccordionScope();
        const heads = this.selector.querySelectorAll(
          `[data-bundle-accordion="${accordionScope}"] .accordion-head`
        );
        heads.forEach((label) => {
          label.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            const accordion = label.closest('.bundle-accordion');
            const isSibling = accordion?.dataset.bundleAccordionType === 'sibling';
            const siblingHandle = accordion?.dataset.siblingProduct || accordion?.dataset.siblingHandle;

            if (isSibling && siblingHandle) {
              this.loadSiblingProduct(siblingHandle, { userInitiated: true });
            }

            this.setSelectedAccordion(accordion);
          });
        });
      }

      loadSiblingProduct(handle, options = {}) {
        if (!handle) {
          console.error('[BundleSelector] Cannot load sibling product: no handle provided');
          return;
        }

        const sectionId = this.getSectionId();
        const root = (typeof window.Shopify !== 'undefined' && window.Shopify.routes && window.Shopify.routes.root) ? window.Shopify.routes.root : '/';
        
        if (!sectionId) {
          window.location.href = root + 'products/' + handle;
          return;
        }

        const sectionWrapper = document.getElementById('shopify-section-' + sectionId) || this.selector.closest('[data-section-id]')?.parentElement;
        if (!sectionWrapper) {
          console.warn('[BundleSelector] Section wrapper not found, redirecting directly to:', root + 'products/' + handle);
          window.location.href = root + 'products/' + handle;
          return;
        }
        const currentSection = sectionWrapper.querySelector('.sibling-product-section');
        const wasPending = BundleSelectorSibling.isRestoring(currentSection);
        const isDefaultProductLoad =
          currentSection?.dataset?.changeDefaultProduct === 'true' && !options.userInitiated;
        const { product, sibling } = BundleSelectorSibling.sectionProducts(currentSection);
        if (product?.handle === handle) {
          BundleSelectorSibling.finishSectionRestore(currentSection);
          return;
        }

        const qtyInput = currentSection?.querySelector('.quantity-selector-input');
        const lastQuantity = qtyInput ? parseInt(qtyInput.value, 10) : null;
        const lastVariantSelection = BundleSelectorSibling.getVariantOptionSelection(currentSection);
        const urlVariantId = BundleSelectorSibling.urlVariantId();
        const targetProduct = sibling?.handle === handle ? sibling : product?.handle === handle ? product : null;
        const variantForFetch = urlVariantId && BundleSelectorSibling.hasVariant(targetProduct, urlVariantId) ? urlVariantId : null;

        let url = `${root}products/${handle}?sections=${encodeURIComponent(sectionId)}`;
        if (lastQuantity != null && !isNaN(lastQuantity) && lastQuantity >= 1) {
          url += `&quantity=${encodeURIComponent(lastQuantity)}`;
        }
        if (variantForFetch) url += `&variant=${encodeURIComponent(variantForFetch)}`;

        sectionWrapper.classList.add('is-loading');
        // API request to render the section
        fetch(url)
          .then((res) => {
            if (!res.ok) {
              throw new Error(`HTTP error! status: ${res.status}`);
            }
            return res.json();
          })
          .then((data) => {
            const raw = data[sectionId];
            if (raw == null) {
              console.warn('[BundleSelector] Section data not found in response, redirecting to:', root + 'products/' + handle);
              window.location.href = root + 'products/' + handle;
              return;
            }
            const parser = new DOMParser();
            const doc = parser.parseFromString(raw, 'text/html');
            const newContent = doc.body.firstElementChild || doc.body.querySelector('[id^="shopify-section-"]');
            if (!newContent) {
              console.warn('[BundleSelector] Could not parse new content, redirecting to:', root + 'products/' + handle);
              sectionWrapper.classList.remove('is-loading');
              window.location.href = root + 'products/' + handle;
              return;
            }

            // Restore last quantity selected into quantity selectors in newContent
            if (lastQuantity != null && !isNaN(lastQuantity) && lastQuantity >= 1) {
              const sectionEl = newContent.querySelector('.sibling-product-section');
              const sectionMax = sectionEl ? parseInt(sectionEl.getAttribute('data-quantity-limitation') || '', 10) : NaN;
              newContent.querySelectorAll('[data-quantity-selector-block]').forEach(function (blockEl) {
                const input = blockEl.querySelector('.quantity-selector-input');
                if (!input) return;
                const min = parseInt(blockEl.dataset.min, 10) || 1;
                const max = parseInt(blockEl.dataset.max, 10) || 99;
                const maxVal = (!isNaN(sectionMax) && sectionMax > 0) ? sectionMax : max;
                const clamped = Math.max(min, Math.min(maxVal, lastQuantity));
                input.value = clamped;
              });
            }

            // Extract scripts before inserting into DOM (scripts from DOMParser don't execute automatically)
            const scriptsToExecute = [];
            const scripts = Array.from(newContent.querySelectorAll('script'));
            scripts.forEach((script) => {
              const scriptData = {
                src: script.src || null,
                content: script.textContent || script.innerHTML || '',
                attributes: {}
              };
              Array.from(script.attributes).forEach(attr => {
                scriptData.attributes[attr.name] = attr.value;
              });
              scriptsToExecute.push(scriptData);
              // Remove script from DOM fragment (it will be re-executed after insertion)
              script.remove();
            });

            const newSectionEl = newContent.querySelector('.sibling-product-section');
            if (wasPending && newSectionEl) {
              newSectionEl.classList.add('sibling-product-section--pending-load');
            }

            const currentWrapper = document.getElementById('shopify-section-' + sectionId);
            if (currentWrapper) {
              currentWrapper.replaceWith(newContent);
            } else {
              sectionWrapper.innerHTML = '';
              sectionWrapper.appendChild(newContent);
            }

            if (newSectionEl) {
              newSectionEl.dataset.changeDefaultProduct = 'false';
              newSectionEl.removeAttribute('data-default-product-handle');
            }
            BundleSelectorSibling.finishSectionRestore(newSectionEl);

            // Execute scripts after content is in DOM
            scriptsToExecute.forEach((scriptData) => {
              try {
                const newScript = document.createElement('script');
                Object.keys(scriptData.attributes).forEach(attrName => {
                  newScript.setAttribute(attrName, scriptData.attributes[attrName]);
                });
                if (scriptData.src) {
                  newScript.src = scriptData.src;
                } else if (scriptData.content.trim()) {
                  newScript.textContent = scriptData.content;
                }
                // Append to the section or document head
                const target = newContent.querySelector('.sibling-product-section') || newContent || document.head;
                target.appendChild(newScript);
              } catch (error) {
                console.warn('[BundleSelector] Error executing script:', error);
              }
            });
            
            document.dispatchEvent(new CustomEvent('section:refreshed', { detail: { sectionId } }));
            if (typeof window.initQuantitySelectorsInContainer === 'function') {
              window.initQuantitySelectorsInContainer(newContent);
            }
            if (typeof window.initVariantSelectorsInContainer === 'function') {
              window.initVariantSelectorsInContainer(newContent);
            }
            if (typeof window.initAddToCartBlocksInContainer === 'function') {
              window.initAddToCartBlocksInContainer(newContent);
            }
            if (typeof window.initCombinedStickyATC === 'function') {
              window.initCombinedStickyATC();
            }
            if (!variantForFetch) {
              BundleSelectorSibling.applyVariantOptionSelection(newContent, lastVariantSelection);
            }
            this.reinitBundleSelectorsInSection(newContent);
            
            if (typeof window.ProductGallery === 'function') {
              const galleries = newContent.querySelectorAll('[data-gallery-block]');
              galleries.forEach((gallery) => {
                if (!gallery.productGalleryInstance) {
                  gallery.productGalleryInstance = new window.ProductGallery(gallery);
                }
              });
            }

            const newBlocks = newContent.querySelectorAll('[data-bundle-selector-block]');
            newBlocks.forEach(function (blockEl) {
              const instance = blockEl.bundleSelectorSiblingInstance;
              if (!instance) return;
              if (typeof instance.updateMainPrice === 'function') {
                instance.updateMainPrice();
              }
              if (typeof instance.updateShippingPrice === 'function') {
                instance.updateShippingPrice();
              }
              if (typeof instance.updateFrequencyDropdown === 'function') {
                instance.updateFrequencyDropdown();
              }
              if (typeof instance.updateLineItemsToSubscribe === 'function') {
                instance.updateLineItemsToSubscribe();
              }
              if (typeof instance.updateQuantityLimitErrors === 'function') {
                instance.updateQuantityLimitErrors();
              }
            });

            // Yotpo: sibling section swaps don't always include the reviews widget DOM.
            // Sync external Yotpo placeholders to the newly loaded product id, then re-init.
            refreshYotpoWidgetsAfterSiblingSectionReload(newContent);
          })
          .catch((error) => {
            console.error('[BundleSelector] Error loading sibling product:', error);
            BundleSelectorSibling.finishSectionRestore();
            window.location.href = root + 'products/' + handle;
          })
          .finally(() => {
            document.getElementById('shopify-section-' + sectionId)?.classList.remove('is-loading');
          });
      }

      reinitBundleSelectorsInSection(sectionEl) {
        sectionEl.querySelectorAll('[data-bundle-selector-block]').forEach((el) => {
          if (el.querySelector('[data-bundle-accordion-type="main"]') && !el.bundleSelectorSiblingInstance) {
            el.bundleSelectorSiblingInstance = new window.BundleSelectorSibling(el);
          }
        });
      }

      getQuantity() {
        const qtyInput = this.getQuantityInput();
        if (!qtyInput) {
          return this.latestQuantity && this.latestQuantity > 0 ? this.latestQuantity : 1;
        }
        const val = parseInt(qtyInput.value, 10);
        if (!isNaN(val) && val > 0) this.latestQuantity = val;
        return isNaN(val) || val < 1 ? 1 : val;
      }

      getVariantPrice() {
        const price = this.mainAccordion?.dataset.variantPrice || this.selector.dataset.variantPrice;
        return parseInt(price, 10) || 0;
      }

      getSubscriptionUnitPriceCentsForQuantity(qty) {
        const definition = this.getBundleOptions();
        const quantityOption = this.getBundleOptionForQuantity(qty, definition);
        if (!quantityOption || quantityOption.price_per_unit == null || quantityOption.price_per_unit === '') {
          return 0;
        }
        const pricePerUnit = Number(quantityOption.price_per_unit);
        if (!Number.isFinite(pricePerUnit) || pricePerUnit <= 0) {
          return 0;
        }
        return pricePerUnit;
      }

      updateMainPrice() {
        const qty = Math.max(1, parseInt(this.getQuantity(), 10) || 1);
        const priceEls = this.selector.querySelectorAll('[data-bundle-accordion-price]');
        priceEls.forEach((el) => {
          const accordion = el.closest('.bundle-accordion');
          const limitStr = accordion?.dataset?.quantityMaxLimit;
          const limit = (limitStr != null && limitStr !== '') ? parseInt(limitStr, 10) : 0;
          if (limit > 0 && qty > limit) return;
          const isSubscriptionAccordion = accordion?.classList?.contains('bundle-accordion-subscription');
          const variantPrice = accordion?.dataset?.variantPrice != null ? parseInt(accordion.dataset.variantPrice, 10) : 0;
          const subscriptionUnitPrice = this.getSubscriptionUnitPriceCentsForQuantity(qty);
          const total = isSubscriptionAccordion
            ? (subscriptionUnitPrice > 0 ? subscriptionUnitPrice * qty : variantPrice * qty)
            : (variantPrice * qty);
          el.textContent = formatMoney(total);
          const sectionEl = this.getSectionElement();
          const showOriginalWhenExchangeHigher =
            sectionEl?.getAttribute('data-show-original-price-when-exchange-higher') === 'true';
          const originalPriceAttr = accordion?.dataset?.originalPrice;
          const originalEl = accordion?.querySelector('[data-bundle-accordion-original-price]');

          if (
            showOriginalWhenExchangeHigher &&
            isSubscriptionAccordion &&
            accordion?.classList?.contains('selected') &&
            originalEl
          ) {
            const exchangeUnit = this.exchangeAccordion?.dataset?.variantPrice != null
              ? parseInt(this.exchangeAccordion.dataset.variantPrice, 10)
              : 0;
            const exchangeTotal = exchangeUnit * qty;
            const shippingLeftEl = this.subscriptionAccordion?.querySelector('.acc-left [data-subscription-shipping-price]');
            const shippingRightEl = this.subscriptionAccordion?.querySelector('.acc-right [data-subscription-shipping-price]');
            if (exchangeTotal > total) {
              originalEl.textContent = formatMoney(originalPriceAttr * qty);
              originalEl.classList.add('show');
              if (shippingRightEl) shippingRightEl.classList.remove('show');
              if (shippingLeftEl) shippingLeftEl.classList.add('show');
            } else {
              originalEl.classList.remove('show');
              if (shippingLeftEl) shippingLeftEl.classList.remove('show');
              if (shippingRightEl) shippingRightEl.classList.add('show');
            }
          }
        });
      }

      updateShippingPrice() {
        const qty = Math.max(1, parseInt(this.getQuantity(), 10) || 1);

        function updateAccordionShippingFromTiers(accordion, shippingEl, shippingLabels) {
          if (!accordion || !shippingEl) return;
          const raw = accordion.getAttribute('data-sibling-shipping-rules');
          if (!raw) return;
          try {
            const str = raw.replace(/&quot;/g, '"').replace(/&#39;/g, "'").replace(/&amp;/g, '&');
            const tiers = JSON.parse(str);
            const variantPriceCents = parseInt(accordion.dataset.variantPrice, 10) || 0;
            const totalCents = variantPriceCents * qty;
            let shippingPriceDollars = null;
            for (let i = 0; i < (tiers?.length || 0); i++) {
              const t = tiers[i];
              const minTier = Number(t.min_tier) || 0;
              const maxTier = (t.max_tier === 'Infinity' || t.max_tier === '' || t.max_tier == null) ? 999999999 : (Number(t.max_tier) || 0);
              const tierMinCents = minTier * 100;
              const tierMaxCents = maxTier >= 999999998 ? 999999999 : Math.round(maxTier * 100);
              if (totalCents >= tierMinCents && totalCents <= tierMaxCents) {
                shippingPriceDollars = (t.shipping_price != null && t.shipping_price !== '') ? Number(t.shipping_price) : 0;
                break;
              }
            }

            if (shippingPriceDollars != null && shippingPriceDollars > 0) {
              shippingEl.textContent = shippingLabels.shippingLabel + ': ' + formatMoney(shippingPriceDollars * 100);
            } else {
              shippingEl.textContent = shippingLabels.freeShippingLabel;
            }
            shippingEl.style.display = '';
          } catch (err) {
            shippingEl.textContent = '';
            shippingEl.style.display = '';
          }
        }

        const exchangeRulesRaw = this.exchangeAccordion?.getAttribute('data-sibling-shipping-rules');
        if (exchangeRulesRaw && this.exchangeShippingEl) {
          updateAccordionShippingFromTiers(
            this.exchangeAccordion,
            this.exchangeShippingEl,
            this.getAccordionShippingLabels(this.exchangeAccordion)
          );
        }

        const subscriptionRulesRaw = this.subscriptionAccordion?.getAttribute('data-sibling-shipping-rules');
        if (subscriptionRulesRaw && this.subscriptionAccordion) {
          const definition = this.getBundleOptions();
          const quantityOption = this.getBundleOptionForQuantity(qty, definition);
          const shipping = quantityOption?.shipping != null ? Number(quantityOption.shipping) : 0;
          const shippingLabels = this.getAccordionShippingLabels(this.subscriptionAccordion);

          const shippingEls = this.subscriptionAccordion.querySelectorAll('[data-subscription-shipping-price]');
          const setShippingText = (shippingText) => {
            shippingEls.forEach((el) => {
              el.textContent = shippingText;
            });
          };
          const setShippingDisplay = (displayValue) => {
            shippingEls.forEach((el) => {
              el.style.display = displayValue;
            });
          };

          if (!shipping) {
            setShippingText(shippingLabels.freeShippingLabel);
            setShippingDisplay('');
            return;
          }

          setShippingText(shippingLabels.shippingLabel + ': ' + formatMoney(shipping));
          setShippingDisplay('');
        }
      }

      listenForVariantChanges() {
        document.addEventListener('variant:changed', (e) => {
          if (e.detail?.variant && this.mainAccordion) {
            const price = e.detail.variant.price;
            this.currentVariantId = e.detail.variant.id;
            this.selector.setAttribute('data-variant-price', price);
            this.mainAccordion.setAttribute('data-variant-price', price);
            this.updateMainPrice();
            this.updateShippingPrice();
            this.updateLineItemsToSubscribe();
            if (window.matchMedia('(max-width: 991px)').matches) {
              this.scrollToQuantitySelector();
            }
          }
        });
      }

      scrollToQuantitySelector() {
        const qtyBlock = document.querySelector('.quantity-selector-block');
        if (!qtyBlock) return;

        const style = getComputedStyle(qtyBlock);
        const marginTop = parseFloat(style.marginTop) || 0;
        const blockHeightWithMargins = qtyBlock.offsetHeight + marginTop;

        const top = qtyBlock.getBoundingClientRect().top + window.scrollY;
        window.scrollTo({
          top: Math.max(0, top - blockHeightWithMargins),
          behavior: 'smooth',
        });
      }

      updateQuantityLimitErrors() {
        const qty = Math.max(1, parseInt(this.getQuantity(), 10) || 1);
        const accordionScope = this.getAccordionScope();
        const i18n = this.getI18n();
        const accordions = this.selector.querySelectorAll(`[data-bundle-accordion="${accordionScope}"]`);
        accordions.forEach((accordion) => {
          const maxLimitStr = accordion.dataset.quantityMaxLimit;
          const minLimitStr = accordion.dataset.quantityMinLimit;
          const maxLimit = (maxLimitStr != null && maxLimitStr !== '') ? parseInt(maxLimitStr, 10) : 0;
          const minLimit = (minLimitStr != null && minLimitStr !== '') ? parseInt(minLimitStr, 10) : 0;
          const errorEl = accordion.querySelector('[data-quantity-limit-error]');
          if (!errorEl) return;
          if (minLimit > 0 && qty < minLimit) {
            errorEl.textContent = i18n.quantityMinLimitError.replace('[limit]', String(minLimit));
            errorEl.classList.remove('d-none');
          } else if (maxLimit > 0 && qty > maxLimit) {
            errorEl.textContent = i18n.quantityMaxLimitError.replace('[limit]', String(maxLimit));
            errorEl.classList.remove('d-none');
          } else {
            errorEl.textContent = '';
            errorEl.classList.add('d-none');
          }
        });
      }

      listenForQuantityChanges() {
        const run = () => {
          this.updateMainPrice();
          this.updateShippingPrice();
          this.updateFrequencyDropdown();
          this.updateLineItemsToSubscribe();
          this.updateQuantityLimitErrors();
        };

        document.addEventListener('quantity:changed', (e) => {
          const changedInput = e?.detail?.input || null;
          const sectionEl = this.getSectionElement();
          if (changedInput && sectionEl && !sectionEl.contains(changedInput)) return;
          if (e?.detail?.value != null) {
            const nextQty = parseInt(e.detail.value, 10);
            if (!isNaN(nextQty) && nextQty > 0) this.latestQuantity = nextQty;
          }
          run();
        });

        const form = this.getForm();
        if (form) {
          form.addEventListener('change', (e) => {
            if (e.target && e.target.name === 'quantity') {
              const nextQty = parseInt(e.target.value, 10);
              if (!isNaN(nextQty) && nextQty > 0) this.latestQuantity = nextQty;
              run();
            }
          });
          form.addEventListener('input', (e) => {
            if (e.target && e.target.name === 'quantity') {
              const nextQty = parseInt(e.target.value, 10);
              if (!isNaN(nextQty) && nextQty > 0) this.latestQuantity = nextQty;
              run();
            }
          });
        }

        const qtyInput = this.getQuantityInput();
        if (qtyInput) {
          qtyInput.addEventListener('change', (e) => {
            const nextQty = parseInt(e.target.value, 10);
            if (!isNaN(nextQty) && nextQty > 0) this.latestQuantity = nextQty;
            run();
          });
          qtyInput.addEventListener('input', (e) => {
            const nextQty = parseInt(e.target.value, 10);
            if (!isNaN(nextQty) && nextQty > 0) this.latestQuantity = nextQty;
            run();
          });
        }
      }
    }

    document.addEventListener('DOMContentLoaded', function () {
      document.querySelectorAll('[data-bundle-selector-block]').forEach((el) => {
        if (el.querySelector('[data-bundle-accordion-type="main"]')) {
          el.bundleSelectorSiblingInstance = new BundleSelectorSibling(el);
        }
      });
    });

    window.BundleSelectorSibling = BundleSelectorSibling;
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["bundle-selector"] && !Shopify.designMode) return;
  try {
    (function () {
    class BundleSelector {
      constructor(selectorElement) {
        this.selector = selectorElement;
        this.blockId = selectorElement.dataset.bundleSelectorBlock;
        this.config = window.bundleSelectorData[this.blockId];
        this.lastClickTime = 0;
        this.clickDelay = 300;

        if (!this.config) return;
        this.init();
      }

      init() {
        this.setInitialVariant();
        this.bindEvents();
      }

      setInitialVariant() {
        const urlVariantId = new URLSearchParams(window.location.search).get('variant');
        if (urlVariantId) {
          this.updateForVariantInit(urlVariantId);
        } else if (window.machinePDPInstance?.currentVariant.id) {
          this.updateForVariantInit(window.machinePDPInstance.currentVariant.id);
        } else {
          document.addEventListener(
            'machinePDP:ready',
            () => {
              if (window.machinePDPInstance?.currentVariant.id) {
                this.updateForVariantInit(window.machinePDPInstance.currentVariant.id);
              }
            },
            { once: true }
          );
        }
      }

      bindEvents() {
        this.selector.querySelectorAll(`[data-bundle-accordion="${this.blockId}"] .accordion-head`).forEach((label) => {
          label.addEventListener('click', (e) => this.handleBundleClick(e, label));
        });

        document.addEventListener('variant:changed', (e) => {
          if (e.detail?.source === 'bundle-selector' && e.detail?.blockId === this.blockId) return;
          if (e.detail?.source === 'color-selector') return;
          if (e.detail?.variant) this.updateForVariant(e.detail.variant.id);
        });
        document.addEventListener('color:changed', (e) => {
          if (e.detail?.color) {
            this.handleColorChange(e.detail.color);
          }
        });
      }

      handleColorChange(newColor) {
        const currentVariant = this.config.variants[this.selector.getAttribute('data-current-variant')];
        const currentBundle = currentVariant ? currentVariant.bundle : null;

        this.selector.querySelectorAll(`[data-bundle-accordion="${this.blockId}"]`).forEach((accordion) => {
          const accordionVariant = this.config.variants[accordion.dataset.variantId];
          accordion.style.display = accordionVariant?.color === newColor ? '' : 'none';
        });

        const matchingVariantId = this.findMatchingBundle(newColor, currentBundle);
        
        if (matchingVariantId) {
          const newVariant = this.config.variants[matchingVariantId];
          
          this.selector.setAttribute('data-current-variant', matchingVariantId);
          this.updateBundleName(newVariant.bundle);
          this.updateUI(matchingVariantId);
          this.updatePricing(matchingVariantId);
          this.updateURL(matchingVariantId);

          document.dispatchEvent(
            new CustomEvent('variant:changed', {
              detail: { 
                variant: newVariant, 
                source: 'bundle-selector', 
                blockId: this.blockId 
              },
            })
          );
        }
      }

      handleBundleClick(e, label) {
        const now = Date.now();
        if (now - this.lastClickTime < this.clickDelay) {
          e.preventDefault();
          e.stopPropagation();
          return;
        }
        this.lastClickTime = now;

        const accordion = label.closest('.bundle-accordion');
        if (accordion.classList.contains('selected') || accordion.classList.contains('oos')) {
          e.preventDefault();
          e.stopPropagation();
          return;
        }

        setTimeout(() => this.switchToVariant(accordion.dataset.variantId), 50);
      }

      switchToVariant(variantId) {
        this.selector.setAttribute('data-current-variant', variantId);

        document.dispatchEvent(
          new CustomEvent('variant:changed', {
            detail: {
              variant: this.config.variants[variantId],
              source: 'bundle-selector',
              blockId: this.blockId,
            },
          })
        );

        this.updateURL(variantId);
        this.updateUI(variantId);
        this.updatePricing(variantId);
      }

      updateURL(variantId) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variantId);
        window.history.pushState({ variantId }, '', url);
      }

      updateForVariant(variantId) {
        const variant = this.config.variants[variantId];
        if (!variant) return;

        const currentVariant = this.config.variants[this.selector.getAttribute('data-current-variant')];
        const isColorChange = currentVariant && currentVariant.color !== variant.color;

        this.selector.querySelectorAll(`[data-bundle-accordion="${this.blockId}"]`).forEach((accordion) => {
          const accordionVariant = this.config.variants[accordion.dataset.variantId];
          accordion.style.display = accordionVariant?.color === variant.color ? '' : 'none';
        });

        if (isColorChange) {
          const matchingVariantId = this.findMatchingBundle(variant.color, currentVariant.bundle);
          if (matchingVariantId) {
            this.selector.setAttribute('data-current-variant', matchingVariantId);
            const newVariant = this.config.variants[matchingVariantId];

            this.updateBundleName(newVariant.bundle);
            this.updateUI(matchingVariantId);
            this.updatePricing(matchingVariantId);

            document.dispatchEvent(
              new CustomEvent('variant:changed', {
                detail: { variant: newVariant, source: 'bundle-selector', blockId: this.blockId },
              })
            );

            this.updateURL(matchingVariantId);
            return;
          }
        }

        this.selector.setAttribute('data-current-variant', variantId);
        this.updateBundleName(variant.bundle);
        this.updateUI(variantId);
        this.updatePricing(variantId);
      }

      updateForVariantInit(variantId) {
        const variant = this.config.variants[variantId];
        if (!variant) return;

        const currentVariant = this.config.variants[this.selector.getAttribute('data-current-variant')];
        const isColorChange = currentVariant && currentVariant.color !== variant.color;

        this.selector.querySelectorAll(`[data-bundle-accordion="${this.blockId}"]`).forEach((accordion) => {
          const accordionVariant = this.config.variants[accordion.dataset.variantId];
          accordion.style.display = accordionVariant?.color === variant.color ? '' : 'none';
        });

        requestAnimationFrame(() => {
          document.dispatchEvent(
            new CustomEvent('variant:changed', {
              detail: { variant: variant, source: 'bundle-selector', blockId: this.blockId },
            })
          );
        });

        this.selector.setAttribute('data-current-variant', variantId);
        this.updateBundleName(variant.bundle);
        this.updateUI(variantId);
        this.updatePricing(variantId);
      }

      findMatchingBundle(targetColor, desiredBundle) {
        let matchingId = null;
        let firstAvailableId = null;

        for (const accordion of this.selector.querySelectorAll(`[data-bundle-accordion="${this.blockId}"]`)) {
          const variantId = accordion.dataset.variantId;
          const variant = this.config.variants[variantId];

          if (!variant || variant.color !== targetColor) continue;

          const isAvailable = !accordion.classList.contains('oos') && variant.available;

          if (!firstAvailableId && isAvailable) firstAvailableId = variantId;
          if (variant.bundle === desiredBundle && isAvailable) {
            matchingId = variantId;
            break;
          }
        }

        return matchingId || firstAvailableId;
      }

      updateBundleName(bundleName) {
        document.querySelectorAll('[data-bundle-name]').forEach((el) => (el.textContent = bundleName));
      }

      updateUI(variantId) {
        this.selector.querySelectorAll(`[data-bundle-accordion="${this.blockId}"]`).forEach((accordion) => {
          const isSelected = accordion.dataset.variantId === variantId;
          accordion.classList.toggle('selected', isSelected);

          const radioEl = accordion.querySelector('.radio');
          if (radioEl) {
            radioEl.innerHTML = isSelected
              ? '<svg width="20" height="20" viewBox="0 0 20 20" fill="none"><rect x="0.5" y="0.5" width="19" height="19" rx="9.5" fill="#005BAB"/><path d="M5 10L7.5 13L14 7.5" stroke="white" stroke-width="1.5"/></svg>'
              : '<svg width="20" height="20" viewBox="0 0 20 20" fill="none"><circle cx="10" cy="10" r="9.5" stroke="#1E3A8A" stroke-width="1.5"/></svg>';
          }

          const label = accordion.querySelector('.accordion-head');
          const body = accordion.querySelector('.accordion-body');

          if (label) label.setAttribute('aria-expanded', isSelected);
          if (body) {
            body.classList.toggle('show', isSelected);
            body.setAttribute('aria-hidden', !isSelected);
          }
        });
      }

      updatePricing(variantId) {
        const variant = this.config.variants[variantId];
        if (!variant) return;

        const anchorPrice = variant.price;

        this.selector.querySelectorAll(`[data-bundle-accordion="${this.blockId}"]`).forEach((accordion) => {
          const accordionColor = accordion.dataset.variantColor;
          if (accordionColor !== variant.color) return;

          const isSelected = accordion.dataset.variantId === variantId;
          const variantPrice = parseInt(accordion.dataset.variantPrice);
          const comparePrice = parseInt(accordion.dataset.variantComparePrice) || 0;
          const priceEl = accordion.querySelector('[data-bundle-price]');
          const compareEl = accordion.querySelector('.compare-price');

          if (this.config.pricingMode === 'anchor' && !isSelected) {
            const delta = variantPrice - anchorPrice;
            if (priceEl) {
              priceEl.textContent = delta === 0 ? formatMoney(0) : (delta > 0 ? '+' : delta < 0 ? '-' : '') + formatMoney(Math.abs(delta));
            }
            if (compareEl) compareEl.style.display = 'none';
          } else {
            if (priceEl) priceEl.textContent = formatMoney(variantPrice);
            if (compareEl) {
              if (comparePrice > variantPrice) {
                compareEl.textContent = formatMoney(comparePrice);
                compareEl.style.display = '';
              } else {
                compareEl.style.display = 'none';
              }
            }
          }
        });
      }
    }

    document.addEventListener('DOMContentLoaded', () => {
      document.querySelectorAll('[data-bundle-selector-block]').forEach((selector) => {
        selector.bundleSelectorInstance = new BundleSelector(selector);
      });
    });

    window.BundleSelector = BundleSelector;
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["buy-it-now"] && !Shopify.designMode) return;
  try {
    function getBuyItNowBiId(variant) {
    if (variant?.color && variant?.bundle) {
      return variant.color + ' / ' + variant.bundle;
    }

    return variant?.title || variant?.option1 || '';
  }

  function updateBuyItNowBiAttributes(btn, blockEl, variant) {
    if (!btn || !blockEl || !variant) {
      return;
    }
    
    btn.setAttribute('bi-id', getBuyItNowBiId(variant));
  }

  function updateBuyItNowButtons(variant) {
    document.querySelectorAll('[data-buy-it-now-block]').forEach(function (blockEl) {
      const btn = blockEl.querySelector('[data-buy-it-now-trigger]');
    
      if (!btn) {
        return;
      }
      btn.disabled = !variant.available;
      btn.textContent = variant.available
        ? blockEl.dataset.labelBuyItNow
        : blockEl.dataset.labelOutOfStock;

      updateBuyItNowBiAttributes(btn, blockEl, variant);
    });
  }

  document.addEventListener('variant:changed', function (e) {
    if (e.detail?.variant) {
      updateBuyItNowButtons(e.detail.variant);
    }
  });

  document.addEventListener('click', function (e) {
    const trigger = e.target.closest('[data-buy-it-now-trigger]');
    if (!trigger || trigger.disabled) {
      return;
    }
    e.preventDefault();

    const sectionEl = trigger.closest('[data-buy-it-now-handler-key]');
    if (!sectionEl) {
      console.error('[BuyItNow] No ancestor with data-buy-it-now-handler-key found.', trigger);
      return;
    }

    const handlerKey = sectionEl.dataset.buyItNowHandlerKey;
    const handler = window.BuyItNowHandlers?.[handlerKey];

    if (!handler) {
      console.error('[BuyItNow] No handler registered for key "' + handlerKey + '".', sectionEl);
      return;
    }

    if (typeof handler.validate === 'function' && !handler.validate(sectionEl)) {
      return;
    }

    handler.checkout(sectionEl);
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["color-selection"] && !Shopify.designMode) return;
  try {
    (function () {
    class ColorSelector {
      constructor(selectorElement) {
        this.selector = selectorElement;
        this.blockId = selectorElement.dataset.colorSelectorBlock;
        this.config = this.getConfig();

        if (!this.config) {
          return;
        }

        this.init();
      }

      getConfig() {
        return window.colorSelectorData[this.blockId] || null;
      }

      init() {
        this.sortColorsByAvailability();
        this.assignDefaultVariant();
        this.bindColorButtons();
        this.listenForVariantChanges();

        if (this.config.hasSwatchOverrides) {
          const trySync = () => {
            const currentVariantId = this.selector.getAttribute('data-current-variant');
            const bundleData = window.bundleSelectorData
              ? Object.values(window.bundleSelectorData)[0]
              : null;
            const variant = bundleData && bundleData.variants
              ? bundleData.variants[currentVariantId]
              : null;
            if (variant && variant.bundle) {
              this.refreshSwatchImages(variant.bundle);
            }
          };
          trySync();
          document.addEventListener('machinePDP:ready', trySync, { once: true });
        }
      }

      assignDefaultVariant() {
        const urlParams = new URLSearchParams(window.location.search);
        const urlVariantId = urlParams.get('variant');

        if (urlVariantId) {
          this.updateFromVariant(urlVariantId);
        } else {
          if (window.machinePDPInstance && window.machinePDPInstance.currentVariant.id) {
            this.updateFromVariant(window.machinePDPInstance.currentVariant.id);
          } else {
            document.addEventListener(
              'machinePDP:ready',
              () => {
                if (window.machinePDPInstance && window.machinePDPInstance.currentVariant.id) {
                  this.updateFromVariant(window.machinePDPInstance.currentVariant.id);
                }
              },
              { once: true }
            );
          }
        }
      }

      sortColorsByAvailability() {
        const wrapper = this.selector.querySelector('.color-options-wrapper');
        if (!wrapper) return;

        const buttons = Array.from(wrapper.querySelectorAll(`[data-color-selector="${this.blockId}"]`));

        buttons.sort((a, b) => {
          const aAvailable = !a.classList.contains('oos');
          const bAvailable = !b.classList.contains('oos');

          if (aAvailable === bAvailable) return 0;
          return aAvailable ? -1 : 1;
        });

        buttons.forEach((button) => wrapper.appendChild(button));
      }

      bindColorButtons() {
        const buttons = this.selector.querySelectorAll(`[data-color-selector="${this.blockId}"]`);

        buttons.forEach((button) => {
          button.addEventListener('click', (e) => {
            e.preventDefault();

            if (button.disabled) return;

            const variantId = button.dataset.variantId;
            const color = button.dataset.color;

            if (variantId) {
              this.selectColor(color, variantId);
            }
          });
        });
      }

      selectColor(color, variantId) {
        this.updateColorUI(color);

        document.dispatchEvent(
          new CustomEvent('color:changed', {
            detail: {
              color: color,
              initialVariantId: variantId,
              source: 'color-selector',
              blockId: this.blockId,
            },
          })
        );
      }

      updateColorUI(selectedColor) {
        const buttons = this.selector.querySelectorAll(`[data-color-selector="${this.blockId}"]`);

        buttons.forEach((button) => {
          const buttonColor = button.dataset.color;
          const isSelected = buttonColor === selectedColor;

          button.classList.toggle('selected', isSelected);
          button.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
        });
      }

      listenForVariantChanges() {
        document.addEventListener('variant:changed', (e) => {
          if (e.detail?.source === 'color-selector' && e.detail?.blockId === this.blockId) {
            return;
          }

          if (e.detail?.variant) {
            this.updateFromVariant(e.detail.variant.id, e.detail.variant.color);

            if (this.config.hasSwatchOverrides && e.detail.variant.bundle) {
              this.refreshSwatchImages(e.detail.variant.bundle);
            }
          }
        });

        window.addEventListener('popstate', () => {
          const urlParams = new URLSearchParams(window.location.search);
          const variantId = urlParams.get('variant');
          if (variantId) {
            this.updateFromVariant(variantId);
          }
        });
      }

      updateFromVariant(variantId, color) {
        color = color || null;

        if (color) {
          this.updateColorUI(color);
          this.selector.setAttribute('data-current-variant', variantId);
          return;
        }

        for (const colorName in this.config.colors) {
          const colorData = this.config.colors[colorName];
          const matchingVariant = colorData.variants.find((v) => String(v.id) === String(variantId));
          if (matchingVariant) {
            this.updateColorUI(colorName);
            this.selector.setAttribute('data-current-variant', variantId);
            break;
          }
        }
      }

      refreshSwatchImages(currentBundle) {
        if (!this.config.hasSwatchOverrides) return;

        const overrides = this.config.swatchOverrides || {};
        const normalize = (s) => (s || '').toString().trim();
        const target = normalize(currentBundle);

        const buttonByColor = (colorName) =>
          this.selector.querySelector(
            `[data-color-selector="${this.blockId}"][data-color="${(window.CSS && CSS.escape) ? CSS.escape(colorName) : colorName.replace(/"/g, '\\"')}"]`
          );

        Object.entries(this.config.colors).forEach(([colorName, colorData]) => {
          const button = buttonByColor(colorName);
          if (!button) return;

          const hasMatchingBundle = colorData.variants.some(
            (v) => v.bundle && normalize(v.bundle) === target
          );
          button.style.display = hasMatchingBundle ? '' : 'none';
        });

        const buttons = this.selector.querySelectorAll(`[data-color-selector="${this.blockId}"]`);
        buttons.forEach((button) => {
          if (button.style.display === 'none') return;

          const color = button.dataset.color;
          const colorMap = overrides[color];
          if (!colorMap) return;

          let newUrl = colorMap[currentBundle];
          if (!newUrl) {
            const matchKey = Object.keys(colorMap).find(
              (k) => k !== '_default' && normalize(k) === target
            );
            if (matchKey) newUrl = colorMap[matchKey];
          }
          if (!newUrl) newUrl = colorMap._default;
          if (!newUrl) return;

          let img = button.querySelector('.swatch-img');

          if (img) {
            if (img.getAttribute('src') !== newUrl) {
              img.setAttribute('src', newUrl);
              img.removeAttribute('srcset');
            }
          } else {
            const chip = button.querySelector('.chip-label');
            const newImg = document.createElement('img');
            newImg.className = 'swatch-img';
            newImg.src = newUrl;
            newImg.alt = color;
            newImg.loading = 'lazy';
            newImg.width = 36;
            newImg.height = 67;
            if (chip) {
              chip.replaceWith(newImg);
            } else {
              button.prepend(newImg);
            }
          }
        });
      }
    }

    document.addEventListener('DOMContentLoaded', function () {
      const selectors = document.querySelectorAll('[data-color-selector-block]');

      selectors.forEach((selector) => {
        const instance = new ColorSelector(selector);
        selector.colorSelectorInstance = instance;
      });
    });

    window.ColorSelector = ColorSelector;
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["omnibus-price"] && !Shopify.designMode) return;
  try {
    (function() {
    class OmnibusPrice {
      constructor(element) {
        this.wrapper = element;
        this.toggle = element.querySelector('[data-omnibus-toggle]');
        this.tooltip = element.querySelector('[data-omnibus-tooltip]');
        this.isVisible = false;
        
        this.init();
      }

      init() {
        if (!this.toggle || !this.tooltip) return;
        
        this.bindEvents();
      }

      bindEvents() {
        const isMobile = () => window.matchMedia('(max-width: 768px)').matches;
        let buttonClickInProgress = false;

        this.toggle.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          
          if (isMobile()) {
            this.hideAllOtherTooltips();
            this.toggleTooltip();
          }
        });

        this.toggle.addEventListener('mouseenter', (e) => {
          if (!isMobile()) {
            this.showTooltip();
          }
        });

        this.wrapper.addEventListener('mouseleave', (e) => {
          if (!isMobile()) {
            this.hideTooltip();
          }
        });

        document.addEventListener('click', (e) => {
          if (this.isVisible && !this.wrapper.contains(e.target)) {
            this.hideTooltip();
          }
        });
      }

      hideAllOtherTooltips() {
        const allWrappers = document.querySelectorAll('[data-omnibus-wrapper]');
        allWrappers.forEach((wrapper) => {
          if (wrapper !== this.wrapper && wrapper.omnibusPriceInstance) {
            wrapper.omnibusPriceInstance.hideTooltip();
          }
        });
      }

      toggleTooltip() {
        if (this.isVisible) {
          this.hideTooltip();
        } else {
          this.showTooltip();
        }
      }

      showTooltip() {
        this.tooltip.style.display = 'block';
        this.tooltip.setAttribute('aria-hidden', 'false');
        this.isVisible = true;
      }

      hideTooltip() {
        this.tooltip.style.display = 'none';
        this.tooltip.setAttribute('aria-hidden', 'true');
        this.isVisible = false;
      }
    }

    document.addEventListener('DOMContentLoaded', function() {
      const wrappers = document.querySelectorAll('[data-omnibus-wrapper]');
      
      wrappers.forEach((wrapper) => {
        const instance = new OmnibusPrice(wrapper);
        wrapper.omnibusPriceInstance = instance;
      });
    });

    window.OmnibusPrice = OmnibusPrice;
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["product-gallery"] && !Shopify.designMode) return;
  try {
    (function () {
    class ProductGallery {
      constructor(galleryElement, config = {}) {
        this.gallery = galleryElement;
        this.galleryId = galleryElement.dataset.galleryBlock;
        this.config = config;
        this.mainSwiper = null;
        this.thumbsSwiper = null;
        this.isUpdating = false;
        this.totalThumbs = 0;
        this.lastDirection = null;
        this.lastTrackedMobileSlideIndex = null;

        this.init();
      }

      refreshImageThumbHighlight(realIndex) {
        const videoOpen = this.gallery.classList.contains('video-showing');
        const skipImageActive = videoOpen;

        const thumbs = this.gallery.querySelectorAll(
          `[data-thumbs-swiper][data-gallery-id="${this.galleryId}"] .swiper-slide`
        );
        thumbs.forEach((thumb, index) => {
          const thumbSlideIndex = thumb.getAttribute('data-swiper-slide-index');
          const resolvedThumbIndex =
            thumbSlideIndex !== null && thumbSlideIndex !== ''
              ? parseInt(thumbSlideIndex, 10)
              : index;
          const matchesMain = resolvedThumbIndex === realIndex;
          if (skipImageActive) {
            thumb.classList.remove('swiper-slide-thumb-active');
          } else {
            thumb.classList.toggle('swiper-slide-thumb-active', matchesMain);
          }
        });
      }

      trackMobileSlide(swiper) {
        if (!swiper) return;
        if (!window.matchMedia || !window.matchMedia('(max-width: 991px)').matches) return;
        const idx = typeof swiper.realIndex === 'number' ? swiper.realIndex : null;
        if (idx == null) return;
        if (this.lastTrackedMobileSlideIndex === idx) return;
        this.lastTrackedMobileSlideIndex = idx;

        const activeSlide = swiper.slides && swiper.activeIndex != null ? swiper.slides[swiper.activeIndex] : null;
        if (!activeSlide || !activeSlide.getAttribute) return;
        const biType = activeSlide.getAttribute('bi-type') || '';
        const biId = activeSlide.getAttribute('bi-id') || '';
        if (!biType && !biId) return;

        try {
          (window.preDataLayer = window.preDataLayer || []).push({
            event: 'newEvent',
            newEventData: {
              type: 'Click',
              elementType: biType,
              elementId: 'Swipe',
            },
          });
        } catch (e) {}
      }

      init() {
        this.waitForSwiperAndInit();
        this.bindVideoToggle();
        this.listenForVariantChanges();
      }

      listenForVariantChanges() {
        document.addEventListener('variant:changed', (e) => {
          if (e.detail?.variant) {
            this.updateGalleryForVariant(e.detail.variant.id);
          }
        });
      }

      updateGalleryForVariant(variantId) {
        const galleryData = this.getGalleryData();
        if (!galleryData) {
          return;
        }
        const variantImages = galleryData[String(variantId)];
        if (!variantImages || variantImages.length === 0) {
          return;
        }

        const variantIdString = String(variantId);
        const prev = this.gallery.getAttribute('data-rendered-variant-id');

        if (prev === variantIdString) {
          return;
        }

        this.updateGallery(variantImages);
        this.gallery.setAttribute('data-rendered-variant-id', variantIdString);
      }

      getGalleryData() {
        try {
          const el = document.querySelector('[data-gallery-images]');
          return el ? JSON.parse(el.textContent) : null;
        } catch (e) {
          return null;
        }
      }

      waitForSwiperAndInit() {
        if (typeof Swiper !== 'undefined') {
          this.initializeSwiper();
        } else {
          requestAnimationFrame(() => this.waitForSwiperAndInit());
        }
      }

      initializeSwiper() {
        if (typeof Swiper === 'undefined') {
          return;
        }

        const thumbsEl = this.gallery.querySelector(`[data-thumbs-swiper][data-gallery-id="${this.galleryId}"]`);
        const prevBtn = this.gallery.querySelector(`.thumbs-prev[data-gallery-id="${this.galleryId}"]`);
        const nextBtn = this.gallery.querySelector(`.thumbs-next[data-gallery-id="${this.galleryId}"]`);

        if (thumbsEl && window.innerWidth >= 992) {
          const thumbSlides = thumbsEl.querySelectorAll('.swiper-slide').length;
          this.totalThumbs = thumbSlides;
          const slidesPerView = this.getThumbSlidesPerView(thumbSlides, thumbsEl);
          const canScrollThumbs = thumbSlides > slidesPerView;

          if (prevBtn && nextBtn) {
            if (thumbSlides <= 5) {
              prevBtn.style.display = 'none';
              nextBtn.style.display = 'none';
            } else {
              prevBtn.style.display = '';
              nextBtn.style.display = '';
            }
          }

          this.thumbsSwiper = new Swiper(thumbsEl, {
            direction: 'horizontal',
            spaceBetween: 4,
            slidesPerView: slidesPerView,
            loop: false,
            loopedSlides: 0,
            roundLengths: true,
            watchOverflow: true,
            freeMode: false,
            watchSlidesProgress: true,
            watchSlidesVisibility: true,
            slideToClickedSlide: false,
            centeredSlides: false,
            allowTouchMove: true,
            grabCursor: true,
          });

          thumbsEl.addEventListener('click', (event) => {
            const slide = event.target.closest('.swiper-slide');
            if (slide && this.mainSwiper && this.thumbsSwiper) {
              const clickedIndex = Array.from(this.thumbsSwiper.slides).indexOf(slide);
              if (clickedIndex !== -1) {
                const realIndex = this.thumbsSwiper.slides[clickedIndex].getAttribute('data-swiper-slide-index');
                if (realIndex !== null) {
                  this.mainSwiper.slideToLoop(parseInt(realIndex));
                } else {
                  this.mainSwiper.slideToLoop(clickedIndex);
                }
                this.closeVideo();
              }
            }
          });
        }

        const mainEl = this.gallery.querySelector(`[data-main-swiper][data-gallery-id="${this.galleryId}"]`);
        if (mainEl) {
          const galleryCount = parseInt(mainEl.getAttribute('data-gallery-count')) || 0;
          const self = this;

          const config = {
            loop: true,
            keyboard: { enabled: true },
            on: {
              init: function () {
                if (!self.gallery.classList.contains('video-showing')) {
                  self.refreshImageThumbHighlight(this.realIndex);
                }
              },
              slideChange: function (swiper) {
                const realIndex = swiper.realIndex;

                if (self.thumbsSwiper && self.thumbsSwiper.slides) {
                  self.syncThumbViewport(realIndex);
                }

                self.refreshImageThumbHighlight(realIndex);
                self.trackMobileSlide(swiper);
                self.lastDirection = null;
              },
            },
          };

          if (window.innerWidth < 992) {
            config.pagination = {
              el: '.swiper-pagination',
              clickable: true,
              type: 'bullets',
              renderBullet: function (index, className) {
                if (index < 10) {
                  return '<span class="' + className + '"></span>';
                }
                return '';
              },
            };
          }

          if (this.thumbsSwiper) {
            config.thumbs = {
              swiper: this.thumbsSwiper,

              slideThumbActiveClass: 'swiper-thumb-active-internal',
            };
          }
          this.mainSwiper = new Swiper(mainEl, config);

          if (prevBtn) {
            prevBtn.addEventListener('click', () => {
              if (!this.mainSwiper) {
                return;
              }
              if (this.gallery.classList.contains('video-showing')) {
                this.closeVideo();
                this.resetGalleryPosition();
                return;
              }
              this.lastDirection = 'prev';
              this.mainSwiper.slidePrev();
              this.closeVideo();
            });
          }

          if (nextBtn) {
            nextBtn.addEventListener('click', () => {
              if (!this.mainSwiper) {
                return;
              }
              if (this.gallery.classList.contains('video-showing')) {
                this.closeVideo();
                this.resetGalleryPosition();
                return;
              }
              this.lastDirection = 'next';
              this.mainSwiper.slideNext();
              this.closeVideo();
            });
          }
        }
      }

      bindVideoToggle() {
        const self = this;
        const toggleButtons = this.gallery.querySelectorAll(`[data-video-toggle][data-gallery-id="${this.galleryId}"]`);
        const container = this.gallery.querySelector(`[data-video-container][data-gallery-id="${this.galleryId}"]`);
        const iframe = container?.querySelector('[data-vimeo-iframe]');

        toggleButtons.forEach((btn) => {
          const newBtn = btn.cloneNode(true);
          btn.parentNode.replaceChild(newBtn, btn);

          newBtn.addEventListener('click', () => {
            const container = self.gallery.querySelector(`[data-video-container][data-gallery-id="${self.galleryId}"]`);
            if (!container) {
              return;
            }

            const isShowing = container.classList.contains('d-block');

            if (isShowing) {
              self.closeVideo();
              return;
            }

            const iframe = container.querySelector('[data-vimeo-iframe]');
            const mobilePlayBtn = self.gallery.querySelector('.video-play-btn');
            const desktopVideoBtn = self.gallery.querySelector('.video-fixed .play');

            container.classList.remove('d-none');
            container.classList.add('d-block');
            self.gallery.classList.add('video-showing');
            self.gallery
              .querySelector(`.video-fixed[data-gallery-id="${self.galleryId}"]`)
              ?.classList.add('video-thumb-active');
            self.gallery
              .querySelectorAll(`[data-thumbs-swiper][data-gallery-id="${self.galleryId}"] .swiper-slide`)
              .forEach(function (t) {
                t.classList.remove('swiper-slide-thumb-active');
              });

            if (mobilePlayBtn) {
              mobilePlayBtn.setAttribute('data-video-state', 'pause');
              mobilePlayBtn.setAttribute('aria-label', 'Pause video');
            }
            if (desktopVideoBtn) {
              desktopVideoBtn.textContent = '⏸';
            }
            if (iframe) {
              iframe.contentWindow.postMessage(JSON.stringify({ method: 'play' }), '*');
            }
          });
        });

        if (iframe && container && container.classList.contains('has-placeholder')) {
          let revealed = false;
          const reveal = () => {
            if (revealed) return;
            revealed = true;
            clearTimeout(fallback);
            container.classList.add('is-video-ready');
          };
          const fallback = setTimeout(reveal, 10000);
          if (typeof Vimeo !== 'undefined' && Vimeo.Player) {
            new Vimeo.Player(iframe).on('playing', reveal);
          }
        }
      }

      closeVideo() {
        const container = this.gallery.querySelector(`[data-video-container][data-gallery-id="${this.galleryId}"]`);
        const iframe = container?.querySelector('[data-vimeo-iframe]');
        const mobilePlayBtn = this.gallery.querySelector('.video-play-btn');
        const desktopVideoBtn = this.gallery.querySelector('.video-fixed .play');

        if (!container) {
          return;
        }

        const isShowing = container.classList.contains('d-block');

        if (isShowing) {
          container.classList.remove('d-block');
          container.classList.add('d-none');
          this.gallery.classList.remove('video-showing');
          this.gallery
            .querySelector(`.video-fixed[data-gallery-id="${this.galleryId}"]`)
            ?.classList.remove('video-thumb-active');

          if (mobilePlayBtn) {
            mobilePlayBtn.setAttribute('data-video-state', 'play');
            mobilePlayBtn.setAttribute('aria-label', 'Play video');
          }

          if (desktopVideoBtn) {
            desktopVideoBtn.textContent = '▶';
          }

          if (iframe) {
            iframe.contentWindow.postMessage(JSON.stringify({ method: 'pause' }), '*');
          }

          this.refreshImageThumbHighlight(this.mainSwiper ? this.mainSwiper.realIndex : 0);
        }
      }

      resetGalleryPosition() {
        if (this.mainSwiper) {
          this.mainSwiper.slideToLoop(0, 0, false);
        }
        if (this.thumbsSwiper) {
          if (this.thumbsSwiper.params?.loop) {
            this.thumbsSwiper.slideToLoop(0, 0, false);
          } else {
            this.thumbsSwiper.slideTo(0, 0, false);
          }
        }
        this.refreshImageThumbHighlight(0);
        this.lastDirection = null;
      }

      getThumbSlidesPerView(totalSlides, thumbsEl) {
        if (totalSlides <= 0) {
          return 1;
        }
        return Math.min(6, totalSlides);
      }

      isBadgeFirstOnly() {
        return this.gallery.dataset.galleryBadgeFirstOnly === 'true';
      }

      shouldShowBadge(img, index) {
        return img.badgeText && (!this.isBadgeFirstOnly() || index === 0);
      }

      syncThumbViewport(realIndex) {
        if (!this.thumbsSwiper || !this.thumbsSwiper.slides || !this.thumbsSwiper.slides.length) {
          return;
        }
        const slidesPerView = Math.max(1, Math.floor(this.thumbsSwiper.params.slidesPerView || 1));
        const totalSlides = this.totalThumbs || this.thumbsSwiper.slides.length;
        if (totalSlides <= slidesPerView) {
          return;
        }

        const maxStart = Math.max(0, totalSlides - slidesPerView);
        const currentStart = Math.max(0, Math.min(this.thumbsSwiper.activeIndex || 0, maxStart));
        const currentEnd = currentStart + slidesPerView - 1;
        let targetStart = currentStart;

        if (realIndex > currentEnd) {
          targetStart = realIndex - slidesPerView + 1;
        } else if (realIndex < currentStart) {
          targetStart = realIndex;
        }

        targetStart = Math.max(0, Math.min(targetStart, maxStart));
        if (targetStart !== currentStart) {
          this.thumbsSwiper.slideTo(targetStart);
        }
      }

      toggleThumbsBar(totalSlides) {
        const thumbsBar = this.gallery.querySelector(`.thumbs-bar[data-gallery-id="${this.galleryId}"]`);
        if (!thumbsBar) {
          return;
        }

        thumbsBar.classList.toggle('d-none', totalSlides <= 1);
      }

      updateGallery(images) {
        if (!images || images.length === 0 || this.isUpdating) {
          return;
        }

        this.isUpdating = true;

        this.closeVideo();

        const mainEl = this.gallery.querySelector(`[data-main-swiper][data-gallery-id="${this.galleryId}"]`);

        if (!this.mainSwiper || !this.mainSwiper.initialized) {
          this.recreateGallery(images);
          this.isUpdating = false;
          return;
        }

        const previousSlideCount = parseInt(mainEl?.getAttribute('data-gallery-count'), 10) || 0;
        const newSlideCount = images.length;
        const thumbsEl = this.gallery.querySelector(`[data-thumbs-swiper][data-gallery-id="${this.galleryId}"]`);
        const previousSlidesPerView = this.getThumbSlidesPerView(previousSlideCount, thumbsEl);
        const newSlidesPerView = this.getThumbSlidesPerView(newSlideCount, thumbsEl);
        const previousCanScrollThumbs = previousSlideCount > previousSlidesPerView;
        const newCanScrollThumbs = newSlideCount > newSlidesPerView;

        if (previousSlidesPerView !== newSlidesPerView || previousCanScrollThumbs !== newCanScrollThumbs) {
          this.recreateGallery(images);
          this.isUpdating = false;
          return;
        }

        if (mainEl) {
          mainEl.setAttribute('data-gallery-count', images.length);
        }
        this.toggleThumbsBar(images.length);

        const badgeBg = this.gallery.dataset.galleryBadgeBg || '';
        const badgeColor = this.gallery.dataset.galleryBadgeColor || '';

        const mainSlides = images.map(
          (img, index) => `
          <div class="swiper-slide text-center">
            <div class="img-wrap position-relative">
              <img src="${img.src}" 
                   alt="${img.alt || ''}" 
                   class="hero br-20"
                   width="1058"
                   height="1058"
                   loading="${index === 0 ? 'eager' : 'lazy'}">
              ${
                this.shouldShowBadge(img, index)
                  ? `
                <div class="badge border-top-right-radius-25 border-bottom-right-radius-25 pie-10 pis-15 py-6 position-absolute left-0 zi-2"
                     data-variant-badge
                     style="background: ${badgeBg}; color: ${badgeColor};">
                  <span class="badge-text font-weight-regular fs15 lh15">
                    ${img.badgeText.substring(0, 26)}
                  </span>
                </div>
              `
                  : ''
              }
            </div>
          </div>
        `
        );

        const mainWrapper = mainEl?.querySelector('.swiper-wrapper');
        if (mainWrapper) {
          this.mainSwiper.loopDestroy();
          mainWrapper.innerHTML = mainSlides.join('');
          this.mainSwiper.loopCreate();
        }

        if (this.thumbsSwiper && this.thumbsSwiper.initialized) {
          const thumbSlides = images.map(
            (img) => `
            <div class="swiper-slide thumbs-image br-10">
              <img src="${img.thumb}" alt="${img.alt || ''}" loading="lazy">
            </div>
          `
          );

          const thumbsWrapper = thumbsEl?.querySelector('.swiper-wrapper');
          if (thumbsWrapper) {
            if (this.thumbsSwiper.params.loop) {
              this.thumbsSwiper.loopDestroy();
            }
            thumbsWrapper.innerHTML = thumbSlides.join('');
            if (this.thumbsSwiper.params.loop) {
              this.thumbsSwiper.loopCreate();
            }
          }
          this.totalThumbs = images.length;

          const prevBtn = this.gallery.querySelector(`.thumbs-prev[data-gallery-id="${this.galleryId}"]`);
          const nextBtn = this.gallery.querySelector(`.thumbs-next[data-gallery-id="${this.galleryId}"]`);
          if (prevBtn && nextBtn) {
            if (images.length <= 5) {
              prevBtn.style.display = 'none';
              nextBtn.style.display = 'none';
            } else {
              prevBtn.style.display = '';
              nextBtn.style.display = '';
            }
          }
        }

        this.mainSwiper.update();
        if (this.thumbsSwiper) {
          this.thumbsSwiper.update();
        }

        this.mainSwiper.loopFix();
        if (this.thumbsSwiper) {
          this.thumbsSwiper.loopFix();
        }

        if (this.mainSwiper.thumbs) {
          this.mainSwiper.thumbs.update(true);
        }

        this.resetGalleryPosition();

        this.isUpdating = false;
      }

      recreateGallery(images) {
        if (this.mainSwiper) {
          this.mainSwiper.destroy(true, true);
        }
        if (this.thumbsSwiper) {
          this.thumbsSwiper.destroy(true, true);
        }

        const mainEl = this.gallery.querySelector(`[data-main-swiper][data-gallery-id="${this.galleryId}"]`);
        if (mainEl) {
          mainEl.setAttribute('data-gallery-count', images.length);
        }
        this.toggleThumbsBar(images.length);

        const badgeBg = this.gallery.dataset.galleryBadgeBg || '';
        const badgeColor = this.gallery.dataset.galleryBadgeColor || '';

        const mainWrapper = mainEl?.querySelector('.swiper-wrapper');
        if (mainWrapper) {
          mainWrapper.innerHTML = images
            .map(
              (img, index) => `
      <div class="swiper-slide text-center">
        <div class="img-wrap position-relative">
          <img src="${img.src}" 
               alt="${img.alt || ''}" 
               class="hero br-20"
               width="1058"
               height="1058"
               loading="${index === 0 ? 'eager' : 'lazy'}">
          ${
            this.shouldShowBadge(img, index)
              ? `
            <div class="badge border-top-right-radius-25 border-bottom-right-radius-25 pie-10 pis-15 py-6 position-absolute left-0 zi-2"
                 data-variant-badge
                 style="background: ${badgeBg}; color: ${badgeColor};">
              <span class="badge-text font-weight-regular fs15 lh15">
                ${img.badgeText.substring(0, 26)}
              </span>
            </div>
          `
              : ''
          }
        </div>
      </div>
    `
            )
            .join('');
        }

        const thumbsEl = this.gallery.querySelector(`[data-thumbs-swiper][data-gallery-id="${this.galleryId}"]`);
        const thumbsWrapper = thumbsEl?.querySelector('.swiper-wrapper');
        if (thumbsWrapper) {
          thumbsWrapper.innerHTML = images
            .map(
              (img) => `
      <div class="swiper-slide thumbs-image br-10">
        <img src="${img.thumb}" alt="${img.alt || ''}" loading="lazy">
      </div>
    `
            )
            .join('');
        }

        this.totalThumbs = images.length;
        this.lastDirection = null;
        this.initializeSwiper();
      }

      destroy() {
        if (this.mainSwiper) {
          this.mainSwiper.destroy(true, true);
        }
        if (this.thumbsSwiper) {
          this.thumbsSwiper.destroy(true, true);
        }
      }
    }

    document.addEventListener('DOMContentLoaded', function () {
      const galleries = document.querySelectorAll('[data-gallery-block]');

      galleries.forEach((gallery) => {
        const instance = new ProductGallery(gallery);
        gallery.productGalleryInstance = instance;
      });
    });

    window.ProductGallery = ProductGallery;
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["promo-badge"] && !Shopify.designMode) return;
  try {
    (function () {
    class PromoBadge {
      constructor(badgeElement) {
        this.badge = badgeElement;
        this.blockId = badgeElement.dataset.promoBadgeBlock;
        this.config = this.getConfig();

        if (!this.config) {
          return;
        }

        this.copyElements = this.badge.querySelectorAll(`[data-promo-copy="${this.blockId}"]`);

        this.init();
      }

      getConfig() {
        try {
          const configEl = document.querySelector(`[data-promo-badge-data="${this.blockId}"]`);
          return configEl ? JSON.parse(configEl.textContent) : null;
        } catch (e) {
          return null;
        }
      }

      init() {
        if (!this.config.promoCode) {
          return;
        }

        this.bindCopyElements();
      }

      bindCopyElements() {
        this.copyElements.forEach((element) => {
          element.style.cursor = 'pointer';

          element.addEventListener('click', async () => {
            const textToCopy = element.dataset.copy || this.config.promoCode;

            if (!textToCopy) return;

            try {
              await this.copyToClipboard(textToCopy);
              this.showCopiedFeedback(element);
            } catch (err) {
              this.fallbackCopy(textToCopy);
            }
          });
        });
      }

      async copyToClipboard(text) {
        if (navigator.clipboard && navigator.clipboard.writeText) {
          await navigator.clipboard.writeText(text);
        } else {
          this.fallbackCopy(text);
        }
      }

      fallbackCopy(text) {
        const textarea = document.createElement('textarea');
        textarea.value = text;
        textarea.style.position = 'fixed';
        textarea.style.opacity = '0';
        document.body.appendChild(textarea);

        textarea.select();
        textarea.setSelectionRange(0, 99999);

        try {
          document.execCommand('copy');
        } catch (err) {}

        document.body.removeChild(textarea);
      }

      showCopiedFeedback(element) {
        const originalHTML = element.innerHTML;
        const originalClasses = element.className;

        element.classList.add('copied');

        const promoCodeElement = this.badge.querySelector('.promo-code');

        if (element.classList.contains('promo-code')) {
          element.innerHTML = this.config.copiedText;
        } else if (element.classList.contains('promo-icon') && promoCodeElement) {
          const originalPromoText = promoCodeElement.innerHTML;
          promoCodeElement.innerHTML = this.config.copiedText;

          setTimeout(() => {
            promoCodeElement.innerHTML = originalPromoText;
          }, 1800);
        }

        setTimeout(() => {
          element.innerHTML = originalHTML;
          element.className = originalClasses;
        }, 1800);
      }
    }

    document.addEventListener('DOMContentLoaded', function () {
      const badges = document.querySelectorAll('[data-promo-badge-block]');

      badges.forEach((badge) => {
        const instance = new PromoBadge(badge);
        badge.promoBadgeInstance = instance;
      });
    });

    window.PromoBadge = PromoBadge;
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["quantity-selector"] && !Shopify.designMode) return;
  try {
    (function () {
    function initQuantitySelector(blockEl) {
      if (blockEl.dataset.quantitySelectorInitialized === 'true') return;
      blockEl.dataset.quantitySelectorInitialized = 'true';

      const input = blockEl.querySelector('.quantity-selector-input');
      const minusBtn = blockEl.querySelector('.quantity-selector-minus');
      const plusBtn = blockEl.querySelector('.quantity-selector-plus');
      let max = parseInt(blockEl.dataset.max, 10) || 99;

      const siblingSection = blockEl.closest('.sibling-product-section');
      if (siblingSection) {
        const sectionMax = parseInt(siblingSection.getAttribute('data-quantity-limitation') || '', 10);
        if (!isNaN(sectionMax) && sectionMax > 0) {
          max = sectionMax;
          blockEl.dataset.max = String(sectionMax);
          if (input) input.max = String(sectionMax);
        }
      }

      if (!input || !minusBtn || !plusBtn) return;

      function getMin() {
        const m = parseInt(blockEl.dataset.min, 10);
        return (!isNaN(m) && m > 0) ? m : 1;
      }

      function getValue() {
        return parseInt(input.value, 10) || getMin();
      }

      function getMax() {
        const sectionEl = blockEl.closest('.sibling-product-section');
        if (sectionEl) {
          const limit = parseInt(sectionEl.getAttribute('data-quantity-limitation') || '', 10);
          if (!isNaN(limit) && limit > 0) return limit;
        }
        return parseInt(blockEl.dataset.max, 10) || max;
      }

      function updateBadgeVisibility() {
        const badgeEl = blockEl.querySelector('.quantity-selector-badge-floating');
        if (!badgeEl) return;
        const showWhen = parseInt(badgeEl.getAttribute('data-badge-show-when') || '0', 10);
        const val = getValue();
        const show = (showWhen === 0) || (val === showWhen);
        badgeEl.classList.toggle('quantity-badge-hidden', !show);
      }

      function pushQuantitySelectionToPreDataLayer(val) {
        const elementType =
          (minusBtn.getAttribute && minusBtn.getAttribute('bi-type')) ||
          (plusBtn.getAttribute && plusBtn.getAttribute('bi-type')) ||
          '';
        (window.preDataLayer = window.preDataLayer || []).push({
          event: 'newEvent',
          newEventData: {
            type: 'Click',
            elementType: elementType,
            elementId: 'Quantity = ' + String(val)
          }
        });
      }

      function setValue(val) {
        const minNow = getMin();
        const maxNow = getMax();
        val = Math.max(minNow, Math.min(maxNow, val));
        const oldVal = input.value;
        input.value = val;
        input.setAttribute('value', String(val));
        if (input.max !== undefined) input.max = String(maxNow);
        if (input.min !== undefined) input.min = String(minNow);
        minusBtn.disabled = val <= minNow;
        plusBtn.disabled = val >= maxNow;
        minusBtn.classList.toggle('disabled', minusBtn.disabled);
        plusBtn.classList.toggle('disabled', plusBtn.disabled);
        updateBadgeVisibility();
        if (oldVal !== String(val)) {
          pushQuantitySelectionToPreDataLayer(val);
          input.dispatchEvent(new Event('change', { bubbles: true }));
          input.dispatchEvent(new Event('input', { bubbles: true }));
          document.dispatchEvent(new CustomEvent('quantity:changed', { 
            detail: { value: val, input: input },
            bubbles: true 
          }));
        }
      }

      function updateButtons() {
        const val = getValue();
        const minNow = getMin();
        const maxNow = getMax();
        minusBtn.disabled = val <= minNow;
        plusBtn.disabled = val >= maxNow;
        minusBtn.classList.toggle('disabled', minusBtn.disabled);
        plusBtn.classList.toggle('disabled', plusBtn.disabled);
      }

      minusBtn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        setValue(getValue() - 1);
      });

      plusBtn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        setValue(getValue() + 1);
      });

      input.addEventListener('change', function () {
        setValue(getValue());
      });

      input.addEventListener('input', function () {
        const minNow = getMin();
        const maxNow = getMax();
        const val = getValue();
        if (val < minNow || val > maxNow) {
          setValue(val);
          return;
        }
        updateButtons();
        updateBadgeVisibility();
      });

      setValue(getValue());
    }

    document.addEventListener('DOMContentLoaded', function () {
      document.querySelectorAll('[data-quantity-selector-block]').forEach(initQuantitySelector);
    });

    if (document.readyState !== 'loading') {
      document.querySelectorAll('[data-quantity-selector-block]').forEach(initQuantitySelector);
    }

    window.initQuantitySelectorsInContainer = function (container) {
      if (!container) return;
      container.querySelectorAll('[data-quantity-selector-block]').forEach(initQuantitySelector);
    };
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["sticky-add-to-cart"] && !Shopify.designMode) return;
  try {
    (function () {
    class StickyATC {
      constructor(stickyElement) {
        this.sticky = stickyElement;
        this.blockId = stickyElement.dataset.stickyAtcBlock;
        this.config = this.getConfig();

        if (!this.config) {
          return;
        }

        this.mainAtcButton = null;
        this.stickyButton = this.sticky.querySelector('[data-sticky-atc-btn]');

        this.init();
      }

      getConfig() {
        return window.stickyATCData[this.blockId] || null;
      }

      init() {
        this.findMainAtcButton();
        this.updateButtonState(this.config.currentVariant);
        this.observeMainButton();
        this.bindStickyButton();
        this.listenForVariantChanges();
        this.assignDefaultVariant();
      }

      findMainAtcButton() {
        this.mainAtcButton =
          document.querySelector('[data-add-to-cart]') ||
          document.querySelector('button[name="add"]') ||
          document.querySelector('.product-form button[type="submit"]');

        if (!this.mainAtcButton) {
        }
      }

      scrollToMainButton() {
        if (!this.mainAtcButton) return;

        this.mainAtcButton.scrollIntoView({
          behavior: 'smooth',
          block: 'center',
        });
      }

      observeMainButton() {
        if (!this.mainAtcButton) return;

        const observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                this.hideSticky();
              } else {
                this.showSticky();
              }
            });
          },
          { threshold: 0.01 }
        );

        observer.observe(this.mainAtcButton);
      }

      showSticky() {
        this.sticky.style.display = 'block';
      }

      hideSticky() {
        this.sticky.style.display = 'none';
      }

      bindStickyButton() {
        if (!this.stickyButton) return;

        this.stickyButton.addEventListener('click', () => {
          if (this.mainAtcButton && this.mainAtcButton.disabled) {
            this.scrollToMainButton();
            return;
          }

          if (this.stickyButton.disabled) return;

          if (this.mainAtcButton) {
            this.mainAtcButton.click();
            this.scrollToMainButton();
          } else {
            const form =
              document.querySelector('[data-product-form]') || document.querySelector('form[action*="/cart/add"]');
            if (form) {
              form.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
            }
          }
        });
      }

      assignDefaultVariant() {
        const urlParams = new URLSearchParams(window.location.search);
        const urlVariantId = urlParams.get('variant');

        if (urlVariantId) {
          this.setVariantById(urlVariantId);
        } else {
          if (window.machinePDPInstance && window.machinePDPInstance.currentVariant.id) {
            const variant = window.machinePDPInstance.findVariantById(window.machinePDPInstance.currentVariant.id);
            if (variant) {
              this.updateStickyBar(variant);
            }
          } else {
            document.addEventListener(
              'machinePDP:ready',
              () => {
                if (window.machinePDPInstance && window.machinePDPInstance.currentVariant.id) {
                  const variant = window.machinePDPInstance.findVariantById(window.machinePDPInstance.currentVariant.id);
                  if (variant) {
                    this.updateStickyBar(variant);
                  }
                }
              },
              { once: true }
            );
          }
        }
      }

      setVariantById(variantId) {
        if (window.machinePDPInstance) {
          const variant = window.machinePDPInstance.findVariantById(variantId);
          if (variant) {
            this.updateStickyBar(variant);
          }
        } else {
          document.addEventListener(
            'machinePDP:ready',
            () => {
              if (window.machinePDPInstance) {
                const variant = window.machinePDPInstance.findVariantById(variantId);
                if (variant) {
                  this.updateStickyBar(variant);
                }
              }
            },
            { once: true }
          );
        }
      }

      listenForVariantChanges() {
        document.addEventListener('variant:changed', (e) => {
          if (e.detail?.variant) {
            this.updateStickyBar(e.detail.variant);
          }
        });
      }

      updateStickyBar(variant) {
        this.sticky.setAttribute('data-current-variant-id', variant.id);
        this.updateBundleName(variant);
        this.updatePrice(variant);
        this.updateButtonState(variant);
        this.observeMainButton();
      }

      updateBundleName(variant) {
        const bundleNameEl = this.sticky.querySelector('[data-bundle-name]');
        if (!bundleNameEl) return;

        let bundleName = null;

        if (variant.bundle) {
          bundleName = variant.bundle;
        } else {
          const optionKey = `option${this.config.bundleOptionIndex + 1}`;
          if (variant[optionKey]) {
            bundleName = variant[optionKey];
          } else if (variant.options && Array.isArray(variant.options)) {
            bundleName = variant.options[this.config.bundleOptionIndex];
          } else if (variant.name) {
            const parts = variant.name.split(' - ')[1];
            if (parts) {
              const options = parts.split(' / ');
              bundleName = options[this.config.bundleOptionIndex];
            }
          }
        }

        if (!bundleName) {
          return;
        }
        bundleNameEl.textContent = bundleName;
        if (this.stickyButton) {
          this.stickyButton.setAttribute('bi-id', bundleName);
        }
      }

      updatePrice(variant) {
        const priceEl = this.sticky.querySelector('[data-product-price]');
        if (priceEl) {
          priceEl.textContent = formatMoney(variant.price);
        }
      }

      updateButtonState(variant) {
        if (!this.stickyButton) return;

        if (variant.available) {
          this.sticky.classList.remove('unavailable-variant');
        } else {
          this.sticky.classList.add('unavailable-variant');
        }
      }
    }

    document.addEventListener('DOMContentLoaded', function () {
      const stickyBars = document.querySelectorAll('[data-sticky-atc-block]');

      stickyBars.forEach((sticky) => {
        const instance = new StickyATC(sticky);
        sticky.stickyATCInstance = instance;
      });
    });

    window.StickyATC = StickyATC;
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["variant-banner"] && !Shopify.designMode) return;
  try {
    (function () {
    class VariantBanner {
      constructor(bannerElement) {
        this.banner = bannerElement;
        this.content = bannerElement.querySelector('[data-variant-banner-content]');
        this.panels = bannerElement.querySelectorAll('[data-variant-banner-panel]');

        if (!this.content || !this.panels.length) return;

        this.listenForVariantChanges();
      }

      updateBanner(variantId) {
        const variantKey = String(variantId);
        let matched = false;

        this.panels.forEach((panel) => {
          const isMatch = panel.dataset.variantId === variantKey;
          panel.hidden = !isMatch;

          if (isMatch) {
            matched = true;
            const details = panel.querySelector('details');
            if (details) {
              details.open = false;
            }
          }
        });

        this.content.hidden = !matched;
        this.banner.setAttribute('data-current-variant', variantKey);
      }

      listenForVariantChanges() {
        document.addEventListener('variant:changed', (e) => {
          if (e.detail?.variant) {
            this.updateBanner(e.detail.variant.id || e.detail.variant);
          }
        });

        document.addEventListener('change', (e) => {
          if (e.target.name === 'id' && e.target.tagName === 'SELECT' && e.target.value) {
            this.updateBanner(e.target.value);
          }
        });

        window.addEventListener('popstate', () => {
          const variantId = new URLSearchParams(window.location.search).get('variant');
          if (variantId) this.updateBanner(variantId);
        });
      }
    }

    document.addEventListener('DOMContentLoaded', () => {
      document.querySelectorAll('[data-variant-banner-block]').forEach((banner) => {
        banner.variantBannerInstance = new VariantBanner(banner);
      });
    });

    window.VariantBanner = VariantBanner;
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["variant-saving-badge"] && !Shopify.designMode) return;
  try {
    (function () {
    if (typeof window.VariantSavingsBadge === 'undefined') {
      class VariantSavingsBadge {
        constructor() {
          this.init();
        }
        init() {
          this.showAppropriateSavingsContainers();
          this.listenForVariantChanges();
        }

        showAppropriateSavingsContainers() {
          const allContainers = document.querySelectorAll('[class^="savings-"], [class*=" savings-"]');

          allContainers.forEach((container) => {
            const containerVariantId = this.extractVariantIdFromContainer(container);

            if (!containerVariantId) {
              return;
            }

            const badgesInContainer = Array.from(container.querySelectorAll('[data-variant-savings-badge-block]'));

            if (badgesInContainer.length === 0) return;

            const matchingBadges = [];
            const defaultBadges = [];

            badgesInContainer.forEach((badge) => {
              const showInVariants = badge.dataset.showInVariants || '';
              const config = this.getConfigForBadge(badge);

              if (!config || !config.enabled) {
                return;
              }

              if (showInVariants.trim() === '') {
                defaultBadges.push({ badge, config });
              } else if (this.shouldShowInContainer(containerVariantId, showInVariants)) {
                matchingBadges.push({ badge, config });
              }
            });

            let badgeToShow = null;
            let configToUse = null;

            if (matchingBadges.length > 0) {
              badgeToShow = matchingBadges[0].badge;
              configToUse = matchingBadges[0].config;
            } else if (defaultBadges.length > 0) {
              badgeToShow = defaultBadges[0].badge;
              configToUse = defaultBadges[0].config;
            }

            badgesInContainer.forEach((badge) => {
              badge.style.display = 'none';
              badge.setAttribute('data-hidden', '');
            });

            if (badgeToShow && configToUse) {
              const shouldShow = this.updateBadgeContent(badgeToShow, configToUse, containerVariantId);

              if (shouldShow) {
                badgeToShow.style.display = 'inline-block';
                badgeToShow.removeAttribute('data-hidden');
                container.style.display = 'block';
              } else {
                container.style.display = 'none';
              }
            } else {
              container.style.display = 'none';
            }
          });
        }

        getConfigForBadge(badge) {
          const blockId = badge.dataset.variantSavingsBadgeBlock;
          try {
            const configEl = document.querySelector(`[data-variant-savings-badge-data="${blockId}"]`);
            return configEl ? JSON.parse(configEl.textContent) : null;
          } catch (e) {
            return null;
          }
        }

        extractVariantIdFromContainer(container) {
          const classList = Array.from(container.classList);
          const savingsClass = classList.find((cls) => cls.startsWith('savings-'));

          if (savingsClass) {
            return savingsClass.replace('savings-', '');
          }

          return container.dataset.variantId || null;
        }

        shouldShowInContainer(containerVariantId, showInVariants) {
          const allowedIds = showInVariants
            .split(',')
            .map((id) => id.trim())
            .filter((id) => id !== '');

          return allowedIds.includes(String(containerVariantId));
        }

        updateBadgeContent(badge, config, variantId) {
          const textElement = badge.querySelector('[data-savings-text]');
          if (!textElement) {
            return false;
          }

          const variantData = config.variants[variantId];
          if (!variantData) {
            return false;
          }

          let displayText = config.text || 'Save';

          if (config.mode === 'text_plus_saving') {
            if (!variantData.hasSavings) return false;

            const savings = variantData.compareAtPrice - variantData.price;
            const amount = config.showSavingsAsPercent
              ? `${Math.round((savings / variantData.compareAtPrice) * 100)}%`
              : formatMoney(savings);
            displayText = `${displayText} ${amount}`;
          }

          textElement.textContent = displayText;
          return true;
        }

        listenForVariantChanges() {
          document.addEventListener('variant:changed', (e) => {
            if (e.detail?.variant) {
              this.updateForVariant(e.detail.variant);
            }
          });
        }

        updateForVariant(variant) {
          const variantId = String(variant.id);
          const allBadges = document.querySelectorAll('[data-variant-savings-badge-block]');
          allBadges.forEach((badge) => {
            badge.setAttribute('data-current-variant', variantId);
          });
          this.showAppropriateSavingsContainers();
        }
      }

      window.VariantSavingsBadge = VariantSavingsBadge;

      if (typeof module !== 'undefined' && module.exports) {
        module.exports = VariantSavingsBadge;
      }

      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function () {
          if (!window.variantSavingsBadgeController) {
            const instance = new VariantSavingsBadge();
            window.variantSavingsBadgeController = instance;
          }
        });
      } else {
        if (!window.variantSavingsBadgeController) {
          const instance = new VariantSavingsBadge();
          window.variantSavingsBadgeController = instance;
        }
      }
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["variant-selector"] && !Shopify.designMode) return;
  try {
    (function () {
    class VariantSelector {
      constructor(selectorElement) {
        this.selector = selectorElement;
        this.blockId = selectorElement.dataset.variantSelectorBlock;
        this.config = this.getConfig();

        if (!this.config) {
          return;
        }

        this.init();
      }

      getConfig() {
        return window.variantSelectorData[this.blockId] || null;
      }

      init() {
        this.bindOptionButtons();
        this.bindWidgetLauncher();
        this.listenForVariantChanges();
        this.applyUrlVariant();
      }

      applyUrlVariant() {
        const variantId = new URLSearchParams(location.search).get('variant');
        if (!variantId) return;
        const selected = this.selector.querySelector('.variant-option.selected');
        if (selected && String(selected.dataset.variantId) === String(variantId)) return;

        for (const valueName in this.config.values) {
          const match = this.config.values[valueName].variants.find((v) => String(v.id) === String(variantId));
          if (match) {
            this.selectOption(valueName, variantId);
            return;
          }
        }
      }

      bindOptionButtons() {
        const buttons = this.selector.querySelectorAll(`[data-variant-selector="${this.blockId}"]`);

        buttons.forEach((button) => {
          button.addEventListener('click', (e) => {
            e.preventDefault();

            if (button.disabled) return;

            const variantId = button.dataset.variantId;
            const optionValue = button.dataset.optionValue;

            if (variantId) {
              this.selectOption(optionValue, variantId);
            }
          });
        });
      }

      bindWidgetLauncher() {
        const launcher = this.selector.querySelector('.widget-gas-launch');
        if (!launcher) return;

        launcher.addEventListener('click', () => {
          launcher.dispatchEvent(
            new CustomEvent('not-sure-widget:open', {
              bubbles: true,
              detail: { group: this.config.group },
            })
          );
        });
      }

      selectCylinderTarget(group, targetIds) {
        if (!group || group !== this.config.group || !targetIds?.length) return;

        const normalizedTargetIds = targetIds.map(String);
        const button = [...this.selector.querySelectorAll(`[data-variant-selector="${this.blockId}"]`)]
          .find((option) => normalizedTargetIds.includes(String(option.dataset.notSureWidgetTarget)));
        const { optionValue, variantId } = button?.dataset || {};

        if (!optionValue || !variantId || button.disabled || button.classList.contains('selected')) return;
        this.selectOption(optionValue, variantId);
      }

      selectOption(optionValue, variantId) {
        this.updateOptionUI(optionValue);
        this.selector.setAttribute('data-current-variant', variantId);

        const variantData = this.getVariantData(optionValue, variantId);

        document.dispatchEvent(
          new CustomEvent('variant:changed', {
            detail: {
              variant: variantData,
              source: 'variant-selector',
              blockId: this.blockId,
            },
          })
        );

        this.updateURL(variantId);
      }

      getVariantData(optionValue, variantId) {
        const valueData = this.config.values[optionValue];
        if (!valueData) return { id: variantId };

        const variant = valueData.variants.find((v) => String(v.id) === String(variantId));
        if (!variant) return { id: variantId };

        const titleParts = variant.title.split(' / ');

        return {
          id: variant.id,
          available: variant.available,
          price: variant.price,
          title: variant.title,
          name: variant.title,
          optionValue: optionValue,
          bundle: titleParts[1] || null,
          option1: titleParts[0] || optionValue,
          option2: titleParts[1] || null,
          option3: titleParts[2] || null,
          options: titleParts,
        };
      }

      updateOptionUI(selectedValue) {
        const buttons = this.selector.querySelectorAll(`[data-variant-selector="${this.blockId}"]`);

        buttons.forEach((button) => {
          const buttonValue = button.dataset.optionValue;
          const isSelected = buttonValue === selectedValue;

          button.classList.toggle('selected', isSelected);
          button.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
        });
      }

      updateURL(variantId) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variantId);
        window.history.pushState({ variantId }, '', url.toString());
      }

      listenForVariantChanges() {
        document.addEventListener('variant:changed', (e) => {
          if (e.detail?.source === 'variant-selector' && e.detail?.blockId === this.blockId) {
            return;
          }

          if (e.detail?.variant) {
            this.updateFromVariant(e.detail.variant.id, e.detail.variant.optionValue);
          }
        });

        window.addEventListener('popstate', () => {
          const urlParams = new URLSearchParams(window.location.search);
          const variantId = urlParams.get('variant');
          if (variantId) {
            this.updateFromVariant(variantId);
          }
        });
      }

      updateFromVariant(variantId, optionValue) {
        optionValue = optionValue || null;

        if (optionValue) {
          this.updateOptionUI(optionValue);
          this.selector.setAttribute('data-current-variant', variantId);
          return;
        }

        for (const valueName in this.config.values) {
          const valueData = this.config.values[valueName];
          const matchingVariant = valueData.variants.find((v) => String(v.id) === String(variantId));
          if (matchingVariant) {
            this.updateOptionUI(valueName);
            this.selector.setAttribute('data-current-variant', variantId);
            break;
          }
        }
      }
    }

    document.addEventListener('DOMContentLoaded', function () {
      const selectors = document.querySelectorAll('[data-variant-selector-block]');

      selectors.forEach((selector) => {
        const instance = new VariantSelector(selector);
        selector.variantSelectorInstance = instance;
      });
    });

    window.VariantSelector = VariantSelector;

    if (!window.variantSelectorNotSureWidgetEventsBound) {
      document.addEventListener('not-sure-widget:cylinder-selected', (e) => {
        document.querySelectorAll('[data-variant-selector-block]').forEach((selector) => {
          const instance = selector.variantSelectorInstance;
          if (typeof instance?.selectCylinderTarget === 'function') {
            instance.selectCylinderTarget(e.detail?.group, e.detail?.targetIds);
          }
        });
      });
      window.variantSelectorNotSureWidgetEventsBound = true;
    }

    window.initVariantSelectorsInContainer = function (container) {
      if (!container) return;
      const selectors = container.querySelectorAll('[data-variant-selector-block]');
      selectors.forEach((selector) => {
        if (selector.variantSelectorInstance) return;
        const instance = new VariantSelector(selector);
        selector.variantSelectorInstance = instance;
      });
    };
  })();
  } catch(e) { console.error(e); }
})();

})();
